import React, { useRef, useState } from "react";
import { useEffect } from "react";
import DatePicker from "react-datepicker";
import { format, parse, isSameDay } from "date-fns";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import LoaderBigTwo from "../../Shared/LoaderBigTwo/LoaderBigTwo";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { Calendar, DateRangePicker } from "react-date-range";
import './SuperAdminLeads.css'

const SuperAdminLeads = () => {
  //////////////////////////////// ACTIVE TAB //////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////

  const [activeTab, setActiveTab] = useState(2);


  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  const [allAdminEmail, setAllAdminEmail] = useState('');

  const handleAdminClickAllButton = (email) => {
    setAllAdminEmail(email.toString());
  };

  console.log("allAdmin", allAdminEmail);

  /////////////////////////////////// MAIN DATA /////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////////

  ///////// ALL APPLICATION

  const [AllApplication, setAllApplication] = useState([]);
  const [loading, setLoading] = useState(true);
  const [AllReactDate, setAllReactDate] = useState([]);
  const [ReactStartDate, ReactSetStartDate] = useState(new Date());
  const [ReactEndDate, ReactSetEndDate] = useState(new Date());

  const fetchApplication = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/allTutors");
      const data = await response.json();
      setAllApplication(data.reverse());
      setAllReactDate(data);
      setApplyEmailData(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Districts:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApplication();
  }, []);

  const [ApplyEmailData, setApplyEmailData] = useState(AllApplication);


  useEffect(() => {
    if (allAdminEmail) {
      const filteredData = AllApplication.filter(
        (application) => application.assignEmail === allAdminEmail
      );
      setApplyEmailData(filteredData);
    } else {
      setApplyEmailData(AllApplication);
    }
  }, [allAdminEmail, AllApplication]);



  //////////////// NEW LEADS ////////////////////////////

  const [newLeads, setNewLeads] = useState([]);
  const [AllReactDateTwo, setAllReactDateTwo] = useState([]);
  const [ReactStartDateTwo, ReactSetStartDateTwo] = useState(new Date());
  const [ReactEndDateTwo, ReactSetEndDateTwo] = useState(new Date());

  const fetchNewLeads = async () => {
    try {
      const response = await fetch(
        "https://tutor-tree-server-1.vercel.app/allTutorsLeads/newLeads"
      );
      const data = await response.json();
      setNewLeads(data.reverse());
      setAllReactDateTwo(data);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching Districts:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNewLeads();
    fetchFollowUpData();
    fetchPublish();
    fetchCancelledData();
  }, []);

  ////////////////  Published  ////////////////////////////

  const [Publish, setPublish] = useState([]);
  const [AllReactDateThree, setAllReactDateThree] = useState([]);
  const [ReactStartDateThree, ReactSetStartDateThree] = useState(new Date());
  const [ReactEndDateThree, ReactSetEndDateThree] = useState(new Date());

  const fetchPublish = async () => {
    try {
      const response = await fetch(
        "https://tutor-tree-server-1.vercel.app/allTutorsLeads/publish"
      );
      const data = await response.json();
      setPublish(data.reverse());
      setAllReactDateThree(data);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching Districts:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPublish();
    fetchFollowUpData();
    fetchCancelledData();
  }, []);

  ////////////////  Follow Up  ////////////////////////////

  const [FollowUp, setFollowUpData] = useState([]);
  const [AllReactDateFour, setAllReactDateFour] = useState([]);
  const [ReactStartDateFour, ReactSetStartDateFour] = useState(new Date());
  const [ReactEndDateFour, ReactSetEndDateFour] = useState(new Date());

  const fetchFollowUpData = async () => {
    try {
      const response = await fetch(
        "https://tutor-tree-server-1.vercel.app/allTutorsLeads/followUp"
      );
      const data = await response.json();
      setFollowUpData(data.reverse());
      setAllReactDateFour(data);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching Districts:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFollowUpData();
    fetchPublish();
    fetchCancelledData();
  }, []);

  ////////////////  Cancelled  ////////////////////////////

  const [Cancelled, setCancelledData] = useState([]);
  const [AllReactDateFive, setAllReactDateFive] = useState([]);
  const [ReactStartDateFive, ReactSetStartDateFive] = useState(new Date());
  const [ReactEndDateFive, ReactSetEndDateFive] = useState(new Date());

  const fetchCancelledData = async () => {
    try {
      const response = await fetch(
        "https://tutor-tree-server-1.vercel.app/allTutorsLeads/cancelled"
      );
      const data = await response.json();
      setCancelledData(data.reverse());
      setAllReactDateFive(data);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching Districts:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCancelledData();
    fetchPublish();
    fetchFollowUpData();
  }, []);

  //////////////////////////////////// ALL HANDLE TO CHANGE ROLE //////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////

  /////////// HANDLE PUBLISH ///////
  //////////////////////////////////

  const handleMakePublish = (id) => {
    fetch(`https://tutor-tree-server-1.vercel.app/allTutors/publish/${id}`, {
      method: "PUT",
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.modifiedCount > 0) {
          toast.success("Published successful.");

          // Re-fetch the updated user data
          fetchPublish();
          fetchApplication();
          fetchCancelledData();
          fetchFollowUpData();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        // Handle any errors that occur during the request
      });
  };

  /////////// HANDLE MAKE FOLLOW UP ////////
  ///////////////////////////////////////////

  const handleMakeFollowUp = (id) => {
    fetch(`https://tutor-tree-server-1.vercel.app/allTutors/followUp/${id}`, {
      method: "PUT",
      body: JSON.stringify({}), // IncludTwo in the request body
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.modifiedCount > 0) {
          toast.success("Follow up successful.");

          // Re-fetch the updated user data
          fetchApplication();
          fetchCancelledData();
          fetchPublish();
          fetchFollowUpData();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        // Handle any errors that occur during the request
      });
  };

  ////////// HANDLE CANCELLED ///////////
  ///////////////////////////////////////

  // published started

  ////////// HANDLE CANCELLED MODAL ///////////
  /////////////////////////////////////////////

  const [selectedReason, setSelectedReason] = useState("");

  const handleMakeCancelled = (id, selectedReason) => {
    if (!selectedReason) {
      toast.error("Please select a reason before submitting.");
      return;
    }

    fetch(`https://tutor-tree-server-1.vercel.app/allTutors/cancelled/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ reason: selectedReason }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.modifiedCount > 0) {
          toast.success("Cancelled successful.");

          // Re-fetch the updated user data
          fetchApplication();
          fetchCancelledData();
          fetchPublish();
          fetchFollowUpData();
          setModalOpen(false);
          // Call the fetchUsers function again to update the user data
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        // Handle any errors that occur during the request
      });
  };

  /////////////////////////////////// All Application search ///////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////

  const [filteredTutors, setFilteredTutors] = useState([]);
  const [searchPerformed, setSearchPerformed] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState("");

  const handleSearch = () => {
    const filteredData = ApplyEmailData.filter((teacher) => {
      // Convert teacher.jobId to a string for comparison
      const matchJobId =
        !selectedJobId || teacher.jobId === selectedJobId.toString();

      return matchJobId;
    });

    setFilteredTutors(filteredData);
    setSearchPerformed(true);
  };

  const displayData = searchPerformed ? filteredTutors : ApplyEmailData;

  /////////////////////////////////// New Leads Search ///////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////

  const [filteredTutorsTwo, setFilteredTutorsTwo] = useState([]);
  const [searchPerformedTwo, setSearchPerformedTwo] = useState(false);
  const [selectedJobIdTwo, setSelectedJobIdTwo] = useState("");

  const handleSearchTwo = () => {
    const filteredData = newLeads.filter((teacher) => {
      // Convert teacher.jobId to a string for comparison
      const matchJobId =
        !selectedJobIdTwo || teacher.jobId === selectedJobIdTwo.toString();

      return matchJobId;
    });

    setFilteredTutorsTwo(filteredData);
    setSearchPerformedTwo(true);
  };

  const displayDataTwo = searchPerformedTwo ? filteredTutorsTwo : newLeads;

  /////////////////////////////////// PUBLISH ///////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////

  const [filteredTutorsThree, setFilteredTutorsThree] = useState([]);
  const [searchPerformedThree, setSearchPerformedThree] = useState(false);
  const [selectedJobIdThree, setSelectedJobIdThree] = useState("");

  const handleSearchThree = () => {
    const filteredData = Publish.filter((teacher) => {
      // Convert teacher.jobId to a string for comparison
      const matchJobId =
        !selectedJobIdThree || teacher.jobId === selectedJobIdThree.toString();

      return matchJobId;
    });

    setFilteredTutorsThree(filteredData);
    setSearchPerformedThree(true);
  };

  const displayDataThree = searchPerformedThree ? filteredTutorsThree : Publish;

  /////////////////////////////////// FollowUp ///////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////

  const [filteredTutorsFour, setFilteredTutorsFour] = useState([]);
  const [searchPerformedFour, setSearchPerformedFour] = useState(false);
  const [selectedJobIdFour, setSelectedJobIdFour] = useState("");

  const handleSearchFour = () => {
    const filteredData = FollowUp.filter((teacher) => {
      // Convert teacher.jobId to a string for comparison
      const matchJobId =
        !selectedJobIdFour || teacher.jobId === selectedJobIdFour.toString();

      return matchJobId;
    });

    setFilteredTutorsFour(filteredData);
    setSearchPerformedFour(true);
  };

  const displayDataFour = searchPerformedFour ? filteredTutorsFour : FollowUp;

  /////////////////////////////////// Cancelled ///////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////

  const [filteredTutorsFive, setFilteredTutorsFive] = useState([]);
  const [searchPerformedFive, setSearchPerformedFive] = useState(false);
  const [selectedJobIdFive, setSelectedJobIdFive] = useState("");

  const handleSearchFive = () => {
    const filteredData = Cancelled.filter((teacher) => {
      // Convert teacher.jobId to a string for comparison
      const matchJobId =
        !selectedJobIdFive || teacher.jobId === selectedJobIdFive.toString();

      return matchJobId;
    });

    setFilteredTutorsFive(filteredData);
    setSearchPerformedFive(true);
  };

  const displayDataFive = searchPerformedFive ? filteredTutorsFive : Cancelled;

  ///////////////////////////////////////////////////////////////////////////
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleButtonClick = (apply) => {
    setSelectedItem(apply);
    setModalOpen(!isModalOpen);
  };

  ///////////// ALL APPLICATION PAGINATION //////////////
  ///////////////////////////////////////////////////////

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Set the number of items to display per page
  const maxPageButtons = 5; // Set the maximum number of pagination buttons to display

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = displayData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPageCount = Math.ceil(displayData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const generatePaginationButtons = () => {
    const pageButtons = [];
    let startPage = 1;
    let endPage = totalPageCount;

    if (totalPageCount > maxPageButtons) {
      if (currentPage <= Math.ceil(maxPageButtons / 2)) {
        endPage = maxPageButtons;
      } else if (
        currentPage >
        totalPageCount - Math.floor(maxPageButtons / 2)
      ) {
        startPage = totalPageCount - maxPageButtons + 1;
      } else {
        startPage = currentPage - Math.floor(maxPageButtons / 2);
        endPage = currentPage + Math.floor(maxPageButtons / 2);
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageButtons.push(
        <li key={i}>
          <button
            onClick={() => handlePageChange(i)}
            className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
              currentPage === i ? "text-blue-600 bg-blue-50" : ""
            }`}
          >
            {i}
          </button>
        </li>
      );
    }

    return pageButtons;
  };

  ///////////// NEW LEADS PAGINATION /////////////////////////
  ////////////////////////////////////////////////////////////

  const [currentPageTwo, setCurrentPageTwo] = useState(1);
  const itemsPerPageTwo = 16;
  const maxPageButtonsTwo = 5;

  const indexOfLastItemTwo = currentPageTwo * itemsPerPageTwo;
  const indexOfFirstItemTwo = indexOfLastItemTwo - itemsPerPageTwo;
  const currentItemsTwo = displayDataTwo.slice(
    indexOfFirstItemTwo,
    indexOfLastItemTwo
  );

  const totalPageCountTwo = Math.ceil(displayDataTwo.length / itemsPerPageTwo);

  const handlePageChangeTwo = (pageNumber) => {
    setCurrentPageTwo(pageNumber);
  };

  const generatePaginationButtonsTwo = () => {
    const pageButtons = [];
    let startPage = 1;
    let endPage = totalPageCountTwo;

    if (totalPageCountTwo > maxPageButtonsTwo) {
      if (currentPageTwo <= Math.ceil(maxPageButtonsTwo / 2)) {
        endPage = maxPageButtonsTwo;
      } else if (
        currentPageTwo >
        totalPageCountTwo - Math.floor(maxPageButtonsTwo / 2)
      ) {
        startPage = totalPageCountTwo - maxPageButtonsTwo + 1;
      } else {
        startPage = currentPageTwo - Math.floor(maxPageButtonsTwo / 2);
        endPage = currentPageTwo + Math.floor(maxPageButtonsTwo / 2);
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageButtons.push(
        <li key={i}>
          <button
            onClick={() => handlePageChangeTwo(i)}
            className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
              currentPageTwo === i ? "text-blue-600 bg-blue-50" : ""
            }`}
          >
            {i}
          </button>
        </li>
      );
    }

    return pageButtons;
  };

  ////////////////////// PUBLISH DATA PAGINATION ///////////////////////////////
  const [currentPageThree, setCurrentPageThree] = useState(1);
  const itemsPerPageThree = 16;
  const maxPageButtonsThree = 5;

  const indexOfLastItemThree = currentPageThree * itemsPerPageThree;
  const indexOfFirstItemThree = indexOfLastItemThree - itemsPerPageThree;
  const currentItemsThree = displayDataThree.slice(
    indexOfFirstItemThree,
    indexOfLastItemThree
  );

  const totalPageCountThree = Math.ceil(
    displayDataThree.length / itemsPerPageThree
  );

  const handlePageChangeThree = (pageNumber) => {
    setCurrentPageThree(pageNumber);
  };

  const generatePaginationButtonsThree = () => {
    const pageButtons = [];
    let startPage = 1;
    let endPage = totalPageCountThree;

    if (totalPageCountThree > maxPageButtonsThree) {
      if (currentPageThree <= Math.ceil(maxPageButtonsThree / 2)) {
        endPage = maxPageButtonsThree;
      } else if (
        currentPageThree >
        totalPageCountThree - Math.floor(maxPageButtonsThree / 2)
      ) {
        startPage = totalPageCountThree - maxPageButtonsThree + 1;
      } else {
        startPage = currentPageThree - Math.floor(maxPageButtonsThree / 2);
        endPage = currentPageThree + Math.floor(maxPageButtonsThree / 2);
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageButtons.push(
        <li key={i}>
          <button
            onClick={() => handlePageChangeThree(i)}
            className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
              currentPageThree === i ? "text-blue-600 bg-blue-50" : ""
            }`}
          >
            {i}
          </button>
        </li>
      );
    }

    return pageButtons;
  };

  ////////////////////// FOLLOW UP DATA PAGINATION ///////////////////////////////
  const [currentPageFour, setCurrentPageFour] = useState(1);
  const itemsPerPageFour = 16;
  const maxPageButtonsFour = 5;

  const indexOfLastItemFour = currentPageFour * itemsPerPageFour;
  const indexOfFirstItemFour = indexOfLastItemFour - itemsPerPageFour;
  const currentItemsFour = displayDataFour.slice(
    indexOfFirstItemFour,
    indexOfLastItemFour
  );

  const totalPageCountFour = Math.ceil(
    displayDataFour.length / itemsPerPageFour
  );

  const handlePageChangeFour = (pageNumber) => {
    setCurrentPageFour(pageNumber);
  };

  const generatePaginationButtonsFour = () => {
    const pageButtons = [];
    let startPage = 1;
    let endPage = totalPageCountFour;

    if (totalPageCountFour > maxPageButtonsFour) {
      if (currentPageFour <= Math.ceil(maxPageButtonsFour / 2)) {
        endPage = maxPageButtonsFour;
      } else if (
        currentPageFour >
        totalPageCountFour - Math.floor(maxPageButtonsFour / 2)
      ) {
        startPage = totalPageCountFour - maxPageButtonsFour + 1;
      } else {
        startPage = currentPageFour - Math.floor(maxPageButtonsFour / 2);
        endPage = currentPageFour + Math.floor(maxPageButtonsFour / 2);
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageButtons.push(
        <li key={i}>
          <button
            onClick={() => handlePageChangeFour(i)}
            className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
              currentPageFour === i ? "text-blue-600 bg-blue-50" : ""
            }`}
          >
            {i}
          </button>
        </li>
      );
    }

    return pageButtons;
  };

  ////////////////////// Cancelled DATA PAGINATION ///////////////////////////////
  const [currentPageFive, setCurrentPageFive] = useState(1);
  const itemsPerPageFive = 16;
  const maxPageButtonsFive = 5;

  const indexOfLastItemFive = currentPageFive * itemsPerPageFive;
  const indexOfFirstItemFive = indexOfLastItemFive - itemsPerPageFive;
  const currentItemsFive = displayDataFive.slice(
    indexOfFirstItemFive,
    indexOfLastItemFive
  );

  const totalPageCountFive = Math.ceil(
    displayDataFive.length / itemsPerPageFive
  );

  const handlePageChangeFive = (pageNumber) => {
    setCurrentPageFive(pageNumber);
  };

  const generatePaginationButtonsFive = () => {
    const pageButtons = [];
    let startPage = 1;
    let endPage = totalPageCountFive;

    if (totalPageCountFive > maxPageButtonsFive) {
      if (currentPageFive <= Math.ceil(maxPageButtonsFive / 2)) {
        endPage = maxPageButtonsFive;
      } else if (
        currentPageFive >
        totalPageCountFive - Math.floor(maxPageButtonsFive / 2)
      ) {
        startPage = totalPageCountFive - maxPageButtonsFive + 1;
      } else {
        startPage = currentPageFive - Math.floor(maxPageButtonsFive / 2);
        endPage = currentPageFive + Math.floor(maxPageButtonsFive / 2);
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageButtons.push(
        <li key={i}>
          <button
            onClick={() => handlePageChangeFive(i)}
            className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
              currentPageFive === i ? "text-blue-600 bg-blue-50" : ""
            }`}
          >
            {i}
          </button>
        </li>
      );
    }

    return pageButtons;
  };

  //////////////////////////////// ALL APPLICATION DATE FILTER ////////////////////////////

  const handleSelect = (date) => {
    let startDate = new Date(date.selection.startDate);
    let endDate = new Date(date.selection.endDate);

    // If the start and end dates are the same, adjust them to cover the entire day
    if (startDate.toDateString() === endDate.toDateString()) {
      startDate.setHours(0, 0, 0, 0); // Set start date to beginning of the day
      endDate.setHours(23, 59, 59, 999); // Set end date to end of the day
    }

    // Convert date strings in your data to Date objects and filter
    let filtered = AllReactDate.filter((product) => {
      let productDate = new Date(product.joiningDate);
      return productDate >= startDate && productDate <= endDate;
    });

    ReactSetStartDate(startDate);
    ReactSetEndDate(endDate);
    setAllApplication(filtered);
    console.log(startDate, endDate);
  };

  const selectionRange = {
    startDate: ReactStartDate,
    endDate: ReactEndDate,
    key: "selection",
  };

  const [isOpenDrop, setIsOpenDrop] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpenDrop(!isOpenDrop);
  };

  const closeDropdown = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpenDrop(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", closeDropdown);

    return () => {
      document.removeEventListener("click", closeDropdown);
    };
  }, []);

  const handleClear = () => {
    ReactSetStartDate(null);
    ReactSetEndDate(null);
    setAllApplication(AllReactDate); // Reset to the original data

    // Clear search-related states
    setFilteredTutors([]);
    setSearchPerformed(false);

    setApplyEmailData(AllApplication)
    setAllAdminEmail('');
  };

  ////////////////////////// New Leads calender filter  //////////////////////////////////////

  const handleSelectTwo = (date) => {
    let startDate = new Date(date.selection.startDate);
    let endDate = new Date(date.selection.endDate);

    // If the start and end dates are the same, adjust them to cover the entire day
    if (startDate.toDateString() === endDate.toDateString()) {
      startDate.setHours(0, 0, 0, 0); // Set start date to beginning of the day
      endDate.setHours(23, 59, 59, 999); // Set end date to end of the day
    }

    // Convert date strings in your data to Date objects and filter
    let filtered = AllReactDateTwo.filter((product) => {
      let productDate = new Date(product.joiningDate);
      return productDate >= startDate && productDate <= endDate;
    });

    ReactSetStartDateTwo(startDate);
    ReactSetEndDateTwo(endDate);
    setNewLeads(filtered);
    console.log(startDate, endDate);
  };

  const selectionRangeTwo = {
    startDate: ReactStartDateTwo,
    endDate: ReactEndDateTwo,
    key: "selection",
  };

  const handleClearTwo = () => {
    ReactSetStartDateTwo(null);
    ReactSetEndDateTwo(null);
    setNewLeads(AllReactDateTwo); // Reset to the original data

    // Clear search-related states
    setFilteredTutorsTwo([]);
    setSearchPerformedTwo(false);
  };
  ////////////////////////// Publish calendar filter //////////////////////////////////////

  const handleSelectThree = (date) => {
    let startDate = new Date(date.selection.startDate);
    let endDate = new Date(date.selection.endDate);

    // If the start and end dates are the same, adjust them to cover the entire day
    if (startDate.toDateString() === endDate.toDateString()) {
      startDate.setHours(0, 0, 0, 0); // Set start date to beginning of the day
      endDate.setHours(23, 59, 59, 999); // Set end date to end of the day
    }

    // Convert date strings in your data to Date objects and filter
    let filtered = AllReactDateThree.filter((product) => {
      let productDate = new Date(product.joiningDate);
      return productDate >= startDate && productDate <= endDate;
    });

    ReactSetStartDateThree(startDate);
    ReactSetEndDateThree(endDate);
    setPublish(filtered);
    console.log(startDate, endDate);
  };

  const selectionRangeThree = {
    startDate: ReactStartDateThree,
    endDate: ReactEndDateThree,
    key: "selection",
  };

  const handleClearThree = () => {
    ReactSetStartDateThree(null);
    ReactSetEndDateThree(null);
    setPublish(AllReactDateThree); // Reset to the original data

    // Clear search-related states
    setFilteredTutorsThree([]);
    setSearchPerformedThree(false);
  };

  ////////////////////////// Follow up calendar filter //////////////////////////////////////

  const handleSelectFour = (date) => {
    let startDate = new Date(date.selection.startDate);
    let endDate = new Date(date.selection.endDate);

    // If the start and end dates are the same, adjust them to cover the entire day
    if (startDate.toDateString() === endDate.toDateString()) {
      startDate.setHours(0, 0, 0, 0); // Set start date to beginning of the day
      endDate.setHours(23, 59, 59, 999); // Set end date to end of the day
    }

    // Convert date strings in your data to Date objects and filter
    let filtered = AllReactDateFour.filter((product) => {
      let productDate = new Date(product.joiningDate);
      return productDate >= startDate && productDate <= endDate;
    });

    ReactSetStartDateFour(startDate);
    ReactSetEndDateFour(endDate);
    setFollowUpData(filtered);
    console.log(startDate, endDate);
  };

  const selectionRangeFour = {
    startDate: ReactStartDateFour,
    endDate: ReactEndDateFour,
    key: "selection",
  };

  const handleClearFour = () => {
    ReactSetStartDateFour(null);
    ReactSetEndDateFour(null);
    setFollowUpData(AllReactDateFour); // Reset to the original data

    // Clear search-related states
    setFilteredTutorsFour([]);
    setSearchPerformedFour(false);
  };

  ////////////////////////// Cancelled calendar filter //////////////////////////////////////

  const handleSelectFive = (date) => {
    let startDate = new Date(date.selection.startDate);
    let endDate = new Date(date.selection.endDate);

    // If the start and end dates are the same, adjust them to cover the entire day
    if (startDate.toDateString() === endDate.toDateString()) {
      startDate.setHours(0, 0, 0, 0); // Set start date to beginning of the day
      endDate.setHours(23, 59, 59, 999); // Set end date to end of the day
    }

    // Convert date strings in your data to Date objects and filter
    let filtered = AllReactDateFive.filter((product) => {
      let productDate = new Date(product.joiningDate);
      return productDate >= startDate && productDate <= endDate;
    });

    ReactSetStartDateFive(startDate);
    ReactSetEndDateFive(endDate);
    setCancelledData(filtered);
    console.log(startDate, endDate);
  };

  const selectionRangeFive = {
    startDate: ReactStartDateFive,
    endDate: ReactEndDateFive,
    key: "selection",
  };

  const handleClearFive = () => {
    ReactSetStartDateFive(null);
    ReactSetEndDateFive(null);
    setFollowUpData(AllReactDateFive); // Reset to the original data

    // Clear search-related states
    setFilteredTutorsFive([]);
    setSearchPerformedFive(false);
  };

  ////////////////////////// End of New Leads calendar filter ////////////////////////////////

  // const [selectedDates, setSelectedDates] = useState({});

  // const handleDateChange = (date, itemId) => {
  //   setSelectedDates((prevDates) => ({
  //     ...prevDates,
  //     [itemId]: date,
  //   }));
  // };

  const [selectedDates, setSelectedDates] = useState(
    currentItemsFour.map(() => new Date())
  );

  // Update the selected date for a specific row
  const handleDateChange = (date, index) => {
    const newDates = [...selectedDates];
    newDates[index] = date;
    setSelectedDates(newDates);
  };

  console.log(selectedDates);

  const handleDateUpdate = async (id, index, selectedDates) => {
    const selectedDate = selectedDates[index];

    if (selectedDate) {
      try {
        const response = await fetch(
          `https://tutor-tree-server-1.vercel.app/followUpDate/${id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              followUpDate: selectedDate.toString(),
            }),
          }
        );

        if (response.ok) {
          toast.success("Updated Date successful.");
          fetchFollowUpData();
          // Additional logic if needed
        } else {
          console.error("Failed to update date");
        }
      } catch (error) {
        console.error("Error:", error.message);
      }
    } else {
      console.error(`No date selected for index ${index}`);
    }
  };



  /////////////////////////////////// ASSIGN START ///////////////////////////////////////

  const [AllAdmin, setAllAdmin] = useState([]);
  const [selectedAdminEmail, setSelectedAdminEmail] = useState({});

  const fetchAllAdmin = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/AdminMainData");
      const data = await response.json();
      setAllAdmin(data);
    } catch (error) {
      console.error("Error fetching Admins:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllAdmin();
  }, []);

  useEffect(() => {
    console.log("Selected Admin Email: ", selectedAdminEmail);
  }, [selectedAdminEmail]);

  async function handleAdminClick(email, itemId) {
    // Use a local variable to store the selected email
    const selectedEmail = email;
  
    try {
      const response = await fetch(`https://tutor-tree-server-1.vercel.app/allTutors/AssignEmail/${itemId}`, {
        method: "PUT",
        body: JSON.stringify({ adminEmail: selectedEmail }),
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      const data = await response.json();
  
      // Check if the request was successful
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      // Check if the update was successful
      if (data.modifiedCount > 0) {
        // Update the state after a successful response
        setSelectedAdminEmail(prevEmails => ({
          ...prevEmails,
          [itemId]: selectedEmail
        }));
  
        toast.success("Assign Successful.");
        fetchApplication();
      } else {
        // Handle the case where no records were modified
        console.error("No records were updated.");
      }
    } catch (error) {
      console.error("Error:", error);
      // Optionally, display an error message to the user
      toast.error("Failed to assign admin.");
    }
  }
  
  
  


  const handleAssign = (itemId) => {
    const selectedEmail = selectedAdminEmail[itemId];
    if (!selectedEmail) {
      console.error("No admin email selected for item:", itemId);
      return;
    }

    fetch(`https://tutor-tree-server-1.vercel.app/allTutors/AssignEmail/${itemId}`, {
      method: "PUT",
      body: JSON.stringify({ adminEmail: selectedEmail }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.modifiedCount > 0) {
          toast.success("Assign Successful.");
          fetchApplication();        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  useEffect(() => {
    fetchApplication();
    fetchAllAdmin();
    // ... other useEffect calls ...
  }, []);

  /////////////////////////////////// ASSIGN END  ///////////////////////////////////////

  return (
    <div className="px-10">
      {activeTab === 1 && (
        <div className="tab-content w-full ">
          <div className="flex justify-between lg:flex-col  py-10 border-b-2 border-orange-500 sm:flex-col">
            <div className="flex justify-end mb-3 ">
              <div ref={dropdownRef} className="">
                <button className="btnCalender  mr-5 " onClick={toggleDropdown}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <path
                      d="M12.1953 1.09375H10.9375V0.4375C10.9375 0.195891 10.7416 0 10.5 0C10.2584 0 10.0625 0.195891 10.0625 0.4375V1.09375H3.9375V0.4375C3.9375 0.195891 3.74164 0 3.5 0C3.25836 0 3.0625 0.195891 3.0625 0.4375V1.09375H1.80469C0.809566 1.09375 0 1.90332 0 2.89844V12.1953C0 13.1904 0.809566 14 1.80469 14H12.1953C13.1904 14 14 13.1904 14 12.1953V2.89844C14 1.90332 13.1904 1.09375 12.1953 1.09375ZM1.80469 1.96875H3.0625V2.40625C3.0625 2.64786 3.25836 2.84375 3.5 2.84375C3.74164 2.84375 3.9375 2.64786 3.9375 2.40625V1.96875H10.0625V2.40625C10.0625 2.64786 10.2584 2.84375 10.5 2.84375C10.7416 2.84375 10.9375 2.64786 10.9375 2.40625V1.96875H12.1953C12.708 1.96875 13.125 2.3858 13.125 2.89844V3.9375H0.875V2.89844C0.875 2.3858 1.29205 1.96875 1.80469 1.96875ZM12.1953 13.125H1.80469C1.29205 13.125 0.875 12.708 0.875 12.1953V4.8125H13.125V12.1953C13.125 12.708 12.708 13.125 12.1953 13.125Z"
                      fill="white"
                    />
                  </svg>{" "}
                  Select Dates{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                  >
                    <path
                      d="M0.166211 1.126L4.13877 5.76188C4.2028 5.83657 4.28223 5.89652 4.37161 5.93762C4.46099 5.97872 4.5582 6 4.65658 6C4.75496 6 4.85217 5.97872 4.94155 5.93762C5.03093 5.89652 5.11036 5.83657 5.17439 5.76188L9.14695 1.126C9.52607 0.683502 9.21175 0 8.62914 0H0.682888C0.100276 0 -0.21405 0.683502 0.166211 1.126Z"
                      fill="white"
                    />
                  </svg>
                </button>
                {isOpenDrop && (
                  <div className="">
                    {/* Dropdown content goes here */}
                    <ul className="mt-10 z-[1] absolute p-2 shadow right-72 bg-base-100 rounded-box w-[470px]">
                      <DateRangePicker
                        ranges={[selectionRange]}
                        onChange={handleSelect}
                        className="w-[400px]"
                      />
                    </ul>
                  </div>
                )}
              </div>
              <Link to="/dashboardTwo/SuperAdminAddLeads">
                <button className="w-32 h-10 ml-2 bg-orange-500 rounded-md hover:bg-orange-600 focus:bg-orange-600">
                  <div className="flex flex-row justify-around items-center px-2">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="14"
                        viewBox="0 0 15 14"
                        fill="none"
                      >
                        <path
                          d="M10.3631 7.02486C10.0941 6.89697 9.81957 6.7868 9.54025 6.69452C10.4449 6.01552 11.0311 4.93432 11.0311 3.71875C11.0311 1.66824 9.3629 0 7.31237 0C5.26183 0 3.59362 1.66824 3.59362 3.71875C3.59362 4.93566 4.18118 6.01792 5.08749 6.69678C4.25711 6.97017 3.47795 7.39556 2.796 7.95648C1.54552 8.98507 0.676067 10.4198 0.34786 11.9963C0.244992 12.4903 0.368231 12.9977 0.68591 13.3883C1.00203 13.7771 1.47079 14 1.97194 14H8.7069C9.00894 14 9.25377 13.7552 9.25377 13.4531C9.25377 13.1511 9.00894 12.9062 8.7069 12.9062H1.97194C1.73848 12.9062 1.59763 12.7759 1.53447 12.6983C1.42539 12.5642 1.38318 12.3896 1.41864 12.2192C1.98616 9.4932 4.39066 7.50187 7.16739 7.43471C7.21549 7.43657 7.2638 7.4375 7.31237 7.4375C7.36139 7.4375 7.4102 7.43654 7.45877 7.43466C8.3097 7.45462 9.1281 7.64881 9.89356 8.0127C10.1664 8.14231 10.4926 8.02635 10.6222 7.75354C10.7519 7.48076 10.6359 7.15452 10.3631 7.02486ZM7.44575 6.34039C7.40137 6.33959 7.35691 6.33918 7.31237 6.33918C7.26823 6.33918 7.2241 6.33962 7.18002 6.34044C5.79383 6.27129 4.68737 5.12181 4.68737 3.71875C4.68737 2.27131 5.86493 1.09375 7.31237 1.09375C8.75981 1.09375 9.93737 2.27131 9.93737 3.71875C9.93737 5.12146 8.83145 6.27071 7.44575 6.34039Z"
                          fill="white"
                        />
                        <path
                          d="M13.7655 10.8555H12.2616V9.35156C12.2616 9.04952 12.0168 8.80469 11.7147 8.80469C11.4127 8.80469 11.1678 9.04952 11.1678 9.35156V10.8555H9.66394C9.3619 10.8555 9.11707 11.1003 9.11707 11.4023C9.11707 11.7044 9.3619 11.9492 9.66394 11.9492H11.1678V13.4531C11.1678 13.7552 11.4127 14 11.7147 14C12.0168 14 12.2616 13.7552 12.2616 13.4531V11.9492H13.7655C14.0675 11.9492 14.3124 11.7044 14.3124 11.4023C14.3124 11.1003 14.0675 10.8555 13.7655 10.8555Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div>
                      <h1 className="addLeadsBtn">Add Leads</h1>
                    </div>
                  </div>
                </button>
              </Link>
            </div>

            <div className="flex flex-row  items-center">
            <button className="dropdown">
  <summary className="py-3 px-4 rounded-md focus:bg-orange-300 btnSelectAdmin bg-orange-100 mt-2  flex justify-center items-center">
    All
  </summary>
  <ul className="p-2 w-64 mt-3  shadow drpArea menu h-56 overflow-auto scrollbar overflow-x-hidden dropdown-content z-[1] bg-base-100 rounded-box">
    {AllAdmin.map(admin => (
      <button
        key={admin.email}
        className="w-full my-2 py-2 px-3 rounded-md textBtnOne mx-1 bg-orange-400 hover:bg-orange-500 focus:bg-orange-500"
        onClick={() => handleAdminClickAllButton(admin.email)}
      >
        {admin.email}
    </button>
    ))}
  </ul>
</button>
              <div className="flex flex-col ml-5">
                <input
                  value={selectedJobId}
                  onChange={(e) => setSelectedJobId(e.target.value)}
                  type="number"
                  placeholder="Job Id"
                  className="input input-bordered input-warning w-full max-w-xs mt-2 "
                />
              </div>

              <button
                className="btnApplyThree flex ml-10 w-36 h-12 mt-2"
                onClick={handleSearch}
              >
                Search
              </button>
              <button
                className="btnClear flex ml-5 w-8 h-12 mt-2 justify-center items-center"
                onClick={handleClear}
              >
                clear
              </button>
 

            </div>
          </div>
        </div>
      )}
      {activeTab === 2 && (
        <div className="tab-content w-full ">
          <div className="flex justify-between lg:flex-col  py-10 border-b-2 border-orange-500 sm:flex-col">
            <div className="flex justify-end mb-3 ">
              <div ref={dropdownRef} className="">
                <button className="btnCalender  mr-5 " onClick={toggleDropdown}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <path
                      d="M12.1953 1.09375H10.9375V0.4375C10.9375 0.195891 10.7416 0 10.5 0C10.2584 0 10.0625 0.195891 10.0625 0.4375V1.09375H3.9375V0.4375C3.9375 0.195891 3.74164 0 3.5 0C3.25836 0 3.0625 0.195891 3.0625 0.4375V1.09375H1.80469C0.809566 1.09375 0 1.90332 0 2.89844V12.1953C0 13.1904 0.809566 14 1.80469 14H12.1953C13.1904 14 14 13.1904 14 12.1953V2.89844C14 1.90332 13.1904 1.09375 12.1953 1.09375ZM1.80469 1.96875H3.0625V2.40625C3.0625 2.64786 3.25836 2.84375 3.5 2.84375C3.74164 2.84375 3.9375 2.64786 3.9375 2.40625V1.96875H10.0625V2.40625C10.0625 2.64786 10.2584 2.84375 10.5 2.84375C10.7416 2.84375 10.9375 2.64786 10.9375 2.40625V1.96875H12.1953C12.708 1.96875 13.125 2.3858 13.125 2.89844V3.9375H0.875V2.89844C0.875 2.3858 1.29205 1.96875 1.80469 1.96875ZM12.1953 13.125H1.80469C1.29205 13.125 0.875 12.708 0.875 12.1953V4.8125H13.125V12.1953C13.125 12.708 12.708 13.125 12.1953 13.125Z"
                      fill="white"
                    />
                  </svg>{" "}
                  Select Dates{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                  >
                    <path
                      d="M0.166211 1.126L4.13877 5.76188C4.2028 5.83657 4.28223 5.89652 4.37161 5.93762C4.46099 5.97872 4.5582 6 4.65658 6C4.75496 6 4.85217 5.97872 4.94155 5.93762C5.03093 5.89652 5.11036 5.83657 5.17439 5.76188L9.14695 1.126C9.52607 0.683502 9.21175 0 8.62914 0H0.682888C0.100276 0 -0.21405 0.683502 0.166211 1.126Z"
                      fill="white"
                    />
                  </svg>
                </button>
                {isOpenDrop && (
                  <div className="">
                    {/* Dropdown content goes here */}
                    <ul className="mt-10 z-[1] absolute p-2 shadow right-72 bg-base-100 rounded-box w-[470px]">
                      <DateRangePicker
                        ranges={[selectionRangeTwo]}
                        onChange={handleSelectTwo}
                        className="w-[400px]"
                      />
                    </ul>
                  </div>
                )}
              </div>
              <Link to="/dashboardTwo/AdminAddLeads">
                <button className="w-32 h-10 ml-2 bg-orange-500 rounded-md hover:bg-orange-600 focus:bg-orange-600">
                  <div className="flex flex-row justify-around items-center px-2">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="14"
                        viewBox="0 0 15 14"
                        fill="none"
                      >
                        <path
                          d="M10.3631 7.02486C10.0941 6.89697 9.81957 6.7868 9.54025 6.69452C10.4449 6.01552 11.0311 4.93432 11.0311 3.71875C11.0311 1.66824 9.3629 0 7.31237 0C5.26183 0 3.59362 1.66824 3.59362 3.71875C3.59362 4.93566 4.18118 6.01792 5.08749 6.69678C4.25711 6.97017 3.47795 7.39556 2.796 7.95648C1.54552 8.98507 0.676067 10.4198 0.34786 11.9963C0.244992 12.4903 0.368231 12.9977 0.68591 13.3883C1.00203 13.7771 1.47079 14 1.97194 14H8.7069C9.00894 14 9.25377 13.7552 9.25377 13.4531C9.25377 13.1511 9.00894 12.9062 8.7069 12.9062H1.97194C1.73848 12.9062 1.59763 12.7759 1.53447 12.6983C1.42539 12.5642 1.38318 12.3896 1.41864 12.2192C1.98616 9.4932 4.39066 7.50187 7.16739 7.43471C7.21549 7.43657 7.2638 7.4375 7.31237 7.4375C7.36139 7.4375 7.4102 7.43654 7.45877 7.43466C8.3097 7.45462 9.1281 7.64881 9.89356 8.0127C10.1664 8.14231 10.4926 8.02635 10.6222 7.75354C10.7519 7.48076 10.6359 7.15452 10.3631 7.02486ZM7.44575 6.34039C7.40137 6.33959 7.35691 6.33918 7.31237 6.33918C7.26823 6.33918 7.2241 6.33962 7.18002 6.34044C5.79383 6.27129 4.68737 5.12181 4.68737 3.71875C4.68737 2.27131 5.86493 1.09375 7.31237 1.09375C8.75981 1.09375 9.93737 2.27131 9.93737 3.71875C9.93737 5.12146 8.83145 6.27071 7.44575 6.34039Z"
                          fill="white"
                        />
                        <path
                          d="M13.7655 10.8555H12.2616V9.35156C12.2616 9.04952 12.0168 8.80469 11.7147 8.80469C11.4127 8.80469 11.1678 9.04952 11.1678 9.35156V10.8555H9.66394C9.3619 10.8555 9.11707 11.1003 9.11707 11.4023C9.11707 11.7044 9.3619 11.9492 9.66394 11.9492H11.1678V13.4531C11.1678 13.7552 11.4127 14 11.7147 14C12.0168 14 12.2616 13.7552 12.2616 13.4531V11.9492H13.7655C14.0675 11.9492 14.3124 11.7044 14.3124 11.4023C14.3124 11.1003 14.0675 10.8555 13.7655 10.8555Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div>
                      <h1 className="addLeadsBtn">Add Leads</h1>
                    </div>
                  </div>
                </button>
              </Link>
            </div>

            <div className="flex flex-row  items-center">
              <div className="flex flex-col ">
                <input
                  value={selectedJobIdTwo}
                  onChange={(e) => setSelectedJobIdTwo(e.target.value)}
                  type="number"
                  placeholder="Job Id"
                  className="input input-bordered input-warning w-full max-w-xs mt-2 "
                />
              </div>

              <button
                className="btnApplyThree flex ml-10 w-36 h-12 mt-2"
                onClick={handleSearchTwo}
              >
                Search
              </button>
              <button
                className="btnClear flex ml-5 w-8 h-12 mt-2 justify-center items-center"
                onClick={handleClearTwo}
              >
                clear
              </button>
            </div>
          </div>
        </div>
      )}
      {activeTab === 3 && (
        <div className="tab-content w-full ">
          <div className="flex justify-between lg:flex-col  py-10 border-b-2 border-orange-500 sm:flex-col">
            <div className="flex justify-end mb-3 ">
              <div ref={dropdownRef} className="">
                <button className="btnCalender  mr-5 " onClick={toggleDropdown}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <path
                      d="M12.1953 1.09375H10.9375V0.4375C10.9375 0.195891 10.7416 0 10.5 0C10.2584 0 10.0625 0.195891 10.0625 0.4375V1.09375H3.9375V0.4375C3.9375 0.195891 3.74164 0 3.5 0C3.25836 0 3.0625 0.195891 3.0625 0.4375V1.09375H1.80469C0.809566 1.09375 0 1.90332 0 2.89844V12.1953C0 13.1904 0.809566 14 1.80469 14H12.1953C13.1904 14 14 13.1904 14 12.1953V2.89844C14 1.90332 13.1904 1.09375 12.1953 1.09375ZM1.80469 1.96875H3.0625V2.40625C3.0625 2.64786 3.25836 2.84375 3.5 2.84375C3.74164 2.84375 3.9375 2.64786 3.9375 2.40625V1.96875H10.0625V2.40625C10.0625 2.64786 10.2584 2.84375 10.5 2.84375C10.7416 2.84375 10.9375 2.64786 10.9375 2.40625V1.96875H12.1953C12.708 1.96875 13.125 2.3858 13.125 2.89844V3.9375H0.875V2.89844C0.875 2.3858 1.29205 1.96875 1.80469 1.96875ZM12.1953 13.125H1.80469C1.29205 13.125 0.875 12.708 0.875 12.1953V4.8125H13.125V12.1953C13.125 12.708 12.708 13.125 12.1953 13.125Z"
                      fill="white"
                    />
                  </svg>{" "}
                  Select Dates{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                  >
                    <path
                      d="M0.166211 1.126L4.13877 5.76188C4.2028 5.83657 4.28223 5.89652 4.37161 5.93762C4.46099 5.97872 4.5582 6 4.65658 6C4.75496 6 4.85217 5.97872 4.94155 5.93762C5.03093 5.89652 5.11036 5.83657 5.17439 5.76188L9.14695 1.126C9.52607 0.683502 9.21175 0 8.62914 0H0.682888C0.100276 0 -0.21405 0.683502 0.166211 1.126Z"
                      fill="white"
                    />
                  </svg>
                </button>
                {isOpenDrop && (
                  <div className="">
                    {/* Dropdown content goes here */}
                    <ul className="mt-10 z-[1] absolute p-2 shadow right-72 bg-base-100 rounded-box w-[470px]">
                      <DateRangePicker
                        ranges={[selectionRangeThree]}
                        onChange={handleSelectThree}
                        className="w-[400px]"
                      />
                    </ul>
                  </div>
                )}
              </div>
              <Link to="/dashboardTwo/AdminAddLeads">
                <button className="w-32 h-10 ml-2 bg-orange-500 rounded-md hover:bg-orange-600 focus:bg-orange-600">
                  <div className="flex flex-row justify-around items-center px-2">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="14"
                        viewBox="0 0 15 14"
                        fill="none"
                      >
                        <path
                          d="M10.3631 7.02486C10.0941 6.89697 9.81957 6.7868 9.54025 6.69452C10.4449 6.01552 11.0311 4.93432 11.0311 3.71875C11.0311 1.66824 9.3629 0 7.31237 0C5.26183 0 3.59362 1.66824 3.59362 3.71875C3.59362 4.93566 4.18118 6.01792 5.08749 6.69678C4.25711 6.97017 3.47795 7.39556 2.796 7.95648C1.54552 8.98507 0.676067 10.4198 0.34786 11.9963C0.244992 12.4903 0.368231 12.9977 0.68591 13.3883C1.00203 13.7771 1.47079 14 1.97194 14H8.7069C9.00894 14 9.25377 13.7552 9.25377 13.4531C9.25377 13.1511 9.00894 12.9062 8.7069 12.9062H1.97194C1.73848 12.9062 1.59763 12.7759 1.53447 12.6983C1.42539 12.5642 1.38318 12.3896 1.41864 12.2192C1.98616 9.4932 4.39066 7.50187 7.16739 7.43471C7.21549 7.43657 7.2638 7.4375 7.31237 7.4375C7.36139 7.4375 7.4102 7.43654 7.45877 7.43466C8.3097 7.45462 9.1281 7.64881 9.89356 8.0127C10.1664 8.14231 10.4926 8.02635 10.6222 7.75354C10.7519 7.48076 10.6359 7.15452 10.3631 7.02486ZM7.44575 6.34039C7.40137 6.33959 7.35691 6.33918 7.31237 6.33918C7.26823 6.33918 7.2241 6.33962 7.18002 6.34044C5.79383 6.27129 4.68737 5.12181 4.68737 3.71875C4.68737 2.27131 5.86493 1.09375 7.31237 1.09375C8.75981 1.09375 9.93737 2.27131 9.93737 3.71875C9.93737 5.12146 8.83145 6.27071 7.44575 6.34039Z"
                          fill="white"
                        />
                        <path
                          d="M13.7655 10.8555H12.2616V9.35156C12.2616 9.04952 12.0168 8.80469 11.7147 8.80469C11.4127 8.80469 11.1678 9.04952 11.1678 9.35156V10.8555H9.66394C9.3619 10.8555 9.11707 11.1003 9.11707 11.4023C9.11707 11.7044 9.3619 11.9492 9.66394 11.9492H11.1678V13.4531C11.1678 13.7552 11.4127 14 11.7147 14C12.0168 14 12.2616 13.7552 12.2616 13.4531V11.9492H13.7655C14.0675 11.9492 14.3124 11.7044 14.3124 11.4023C14.3124 11.1003 14.0675 10.8555 13.7655 10.8555Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div>
                      <h1 className="addLeadsBtn">Add Leads</h1>
                    </div>
                  </div>
                </button>
              </Link>
            </div>

            <div className="flex flex-row  items-center">
              <div className="flex flex-col ">
                <input
                  value={selectedJobIdThree}
                  onChange={(e) => setSelectedJobIdThree(e.target.value)}
                  type="number"
                  placeholder="Job Id"
                  className="input input-bordered input-warning w-full max-w-xs mt-2 "
                />
              </div>

              <button
                className="btnApplyThree flex ml-10 w-36 h-12 mt-2"
                onClick={handleSearchThree}
              >
                Search
              </button>
              <button
                className="btnClear flex ml-5 w-8 h-12 mt-2 justify-center items-center"
                onClick={handleClearThree}
              >
                clear
              </button>
            </div>
          </div>
        </div>
      )}
      {activeTab === 4 && (
        <div className="tab-content w-full ">
          <div className="flex justify-between lg:flex-col  py-10 border-b-2 border-orange-500 sm:flex-col">
            <div className="flex justify-end mb-3 ">
              <div ref={dropdownRef} className="">
                <button className="btnCalender  mr-5 " onClick={toggleDropdown}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <path
                      d="M12.1953 1.09375H10.9375V0.4375C10.9375 0.195891 10.7416 0 10.5 0C10.2584 0 10.0625 0.195891 10.0625 0.4375V1.09375H3.9375V0.4375C3.9375 0.195891 3.74164 0 3.5 0C3.25836 0 3.0625 0.195891 3.0625 0.4375V1.09375H1.80469C0.809566 1.09375 0 1.90332 0 2.89844V12.1953C0 13.1904 0.809566 14 1.80469 14H12.1953C13.1904 14 14 13.1904 14 12.1953V2.89844C14 1.90332 13.1904 1.09375 12.1953 1.09375ZM1.80469 1.96875H3.0625V2.40625C3.0625 2.64786 3.25836 2.84375 3.5 2.84375C3.74164 2.84375 3.9375 2.64786 3.9375 2.40625V1.96875H10.0625V2.40625C10.0625 2.64786 10.2584 2.84375 10.5 2.84375C10.7416 2.84375 10.9375 2.64786 10.9375 2.40625V1.96875H12.1953C12.708 1.96875 13.125 2.3858 13.125 2.89844V3.9375H0.875V2.89844C0.875 2.3858 1.29205 1.96875 1.80469 1.96875ZM12.1953 13.125H1.80469C1.29205 13.125 0.875 12.708 0.875 12.1953V4.8125H13.125V12.1953C13.125 12.708 12.708 13.125 12.1953 13.125Z"
                      fill="white"
                    />
                  </svg>{" "}
                  Select Dates{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                  >
                    <path
                      d="M0.166211 1.126L4.13877 5.76188C4.2028 5.83657 4.28223 5.89652 4.37161 5.93762C4.46099 5.97872 4.5582 6 4.65658 6C4.75496 6 4.85217 5.97872 4.94155 5.93762C5.03093 5.89652 5.11036 5.83657 5.17439 5.76188L9.14695 1.126C9.52607 0.683502 9.21175 0 8.62914 0H0.682888C0.100276 0 -0.21405 0.683502 0.166211 1.126Z"
                      fill="white"
                    />
                  </svg>
                </button>
                {isOpenDrop && (
                  <div className="">
                    {/* Dropdown content goes here */}
                    <ul className="mt-10 z-[1] absolute p-2 shadow right-72 bg-base-100 rounded-box w-[470px]">
                      <DateRangePicker
                        ranges={[selectionRangeFour]}
                        onChange={handleSelectFour}
                        className="w-[400px]"
                      />
                    </ul>
                  </div>
                )}
              </div>
              <Link to="/dashboardTwo/AdminAddLeads">
                <button className="w-32 h-10 ml-2 bg-orange-500 rounded-md hover:bg-orange-600 focus:bg-orange-600">
                  <div className="flex flex-row justify-around items-center px-2">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="14"
                        viewBox="0 0 15 14"
                        fill="none"
                      >
                        <path
                          d="M10.3631 7.02486C10.0941 6.89697 9.81957 6.7868 9.54025 6.69452C10.4449 6.01552 11.0311 4.93432 11.0311 3.71875C11.0311 1.66824 9.3629 0 7.31237 0C5.26183 0 3.59362 1.66824 3.59362 3.71875C3.59362 4.93566 4.18118 6.01792 5.08749 6.69678C4.25711 6.97017 3.47795 7.39556 2.796 7.95648C1.54552 8.98507 0.676067 10.4198 0.34786 11.9963C0.244992 12.4903 0.368231 12.9977 0.68591 13.3883C1.00203 13.7771 1.47079 14 1.97194 14H8.7069C9.00894 14 9.25377 13.7552 9.25377 13.4531C9.25377 13.1511 9.00894 12.9062 8.7069 12.9062H1.97194C1.73848 12.9062 1.59763 12.7759 1.53447 12.6983C1.42539 12.5642 1.38318 12.3896 1.41864 12.2192C1.98616 9.4932 4.39066 7.50187 7.16739 7.43471C7.21549 7.43657 7.2638 7.4375 7.31237 7.4375C7.36139 7.4375 7.4102 7.43654 7.45877 7.43466C8.3097 7.45462 9.1281 7.64881 9.89356 8.0127C10.1664 8.14231 10.4926 8.02635 10.6222 7.75354C10.7519 7.48076 10.6359 7.15452 10.3631 7.02486ZM7.44575 6.34039C7.40137 6.33959 7.35691 6.33918 7.31237 6.33918C7.26823 6.33918 7.2241 6.33962 7.18002 6.34044C5.79383 6.27129 4.68737 5.12181 4.68737 3.71875C4.68737 2.27131 5.86493 1.09375 7.31237 1.09375C8.75981 1.09375 9.93737 2.27131 9.93737 3.71875C9.93737 5.12146 8.83145 6.27071 7.44575 6.34039Z"
                          fill="white"
                        />
                        <path
                          d="M13.7655 10.8555H12.2616V9.35156C12.2616 9.04952 12.0168 8.80469 11.7147 8.80469C11.4127 8.80469 11.1678 9.04952 11.1678 9.35156V10.8555H9.66394C9.3619 10.8555 9.11707 11.1003 9.11707 11.4023C9.11707 11.7044 9.3619 11.9492 9.66394 11.9492H11.1678V13.4531C11.1678 13.7552 11.4127 14 11.7147 14C12.0168 14 12.2616 13.7552 12.2616 13.4531V11.9492H13.7655C14.0675 11.9492 14.3124 11.7044 14.3124 11.4023C14.3124 11.1003 14.0675 10.8555 13.7655 10.8555Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div>
                      <h1 className="addLeadsBtn">Add Leads</h1>
                    </div>
                  </div>
                </button>
              </Link>
            </div>

            <div className="flex flex-row  items-center">
              <div className="flex flex-col ">
                <input
                  value={selectedJobIdFour}
                  onChange={(e) => setSelectedJobIdFour(e.target.value)}
                  type="number"
                  placeholder="Job Id"
                  className="input input-bordered input-warning w-full max-w-xs mt-2 "
                />
              </div>

              <button
                className="btnApplyThree flex ml-10 w-36 h-12 mt-2"
                onClick={handleSearchFour}
              >
                Search
              </button>
              <button
                className="btnClear flex ml-5 w-8 h-12 mt-2 justify-center items-center"
                onClick={handleClearFour}
              >
                clear
              </button>
            </div>
          </div>
        </div>
      )}
      {activeTab === 5 && (
        <div className="tab-content w-full ">
          <div className="flex justify-between lg:flex-col  py-10 border-b-2 border-orange-500 sm:flex-col">
            <div className="flex justify-end mb-3 ">
              <div ref={dropdownRef} className="">
                <button className="btnCalender  mr-5 " onClick={toggleDropdown}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <path
                      d="M12.1953 1.09375H10.9375V0.4375C10.9375 0.195891 10.7416 0 10.5 0C10.2584 0 10.0625 0.195891 10.0625 0.4375V1.09375H3.9375V0.4375C3.9375 0.195891 3.74164 0 3.5 0C3.25836 0 3.0625 0.195891 3.0625 0.4375V1.09375H1.80469C0.809566 1.09375 0 1.90332 0 2.89844V12.1953C0 13.1904 0.809566 14 1.80469 14H12.1953C13.1904 14 14 13.1904 14 12.1953V2.89844C14 1.90332 13.1904 1.09375 12.1953 1.09375ZM1.80469 1.96875H3.0625V2.40625C3.0625 2.64786 3.25836 2.84375 3.5 2.84375C3.74164 2.84375 3.9375 2.64786 3.9375 2.40625V1.96875H10.0625V2.40625C10.0625 2.64786 10.2584 2.84375 10.5 2.84375C10.7416 2.84375 10.9375 2.64786 10.9375 2.40625V1.96875H12.1953C12.708 1.96875 13.125 2.3858 13.125 2.89844V3.9375H0.875V2.89844C0.875 2.3858 1.29205 1.96875 1.80469 1.96875ZM12.1953 13.125H1.80469C1.29205 13.125 0.875 12.708 0.875 12.1953V4.8125H13.125V12.1953C13.125 12.708 12.708 13.125 12.1953 13.125Z"
                      fill="white"
                    />
                  </svg>{" "}
                  Select Dates{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                  >
                    <path
                      d="M0.166211 1.126L4.13877 5.76188C4.2028 5.83657 4.28223 5.89652 4.37161 5.93762C4.46099 5.97872 4.5582 6 4.65658 6C4.75496 6 4.85217 5.97872 4.94155 5.93762C5.03093 5.89652 5.11036 5.83657 5.17439 5.76188L9.14695 1.126C9.52607 0.683502 9.21175 0 8.62914 0H0.682888C0.100276 0 -0.21405 0.683502 0.166211 1.126Z"
                      fill="white"
                    />
                  </svg>
                </button>
                {isOpenDrop && (
                  <div className="">
                    {/* Dropdown content goes here */}
                    <ul className="mt-10 z-[1] absolute p-2 shadow right-72 bg-base-100 rounded-box w-[470px]">
                      <DateRangePicker
                        ranges={[selectionRangeFive]}
                        onChange={handleSelectFive}
                        className="w-[400px]"
                      />
                    </ul>
                  </div>
                )}
              </div>
              <Link to="/dashboardTwo/AdminAddLeads">
                <button className="w-32 h-10 ml-2 bg-orange-500 rounded-md hover:bg-orange-600 focus:bg-orange-600">
                  <div className="flex flex-row justify-around items-center px-2">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="14"
                        viewBox="0 0 15 14"
                        fill="none"
                      >
                        <path
                          d="M10.3631 7.02486C10.0941 6.89697 9.81957 6.7868 9.54025 6.69452C10.4449 6.01552 11.0311 4.93432 11.0311 3.71875C11.0311 1.66824 9.3629 0 7.31237 0C5.26183 0 3.59362 1.66824 3.59362 3.71875C3.59362 4.93566 4.18118 6.01792 5.08749 6.69678C4.25711 6.97017 3.47795 7.39556 2.796 7.95648C1.54552 8.98507 0.676067 10.4198 0.34786 11.9963C0.244992 12.4903 0.368231 12.9977 0.68591 13.3883C1.00203 13.7771 1.47079 14 1.97194 14H8.7069C9.00894 14 9.25377 13.7552 9.25377 13.4531C9.25377 13.1511 9.00894 12.9062 8.7069 12.9062H1.97194C1.73848 12.9062 1.59763 12.7759 1.53447 12.6983C1.42539 12.5642 1.38318 12.3896 1.41864 12.2192C1.98616 9.4932 4.39066 7.50187 7.16739 7.43471C7.21549 7.43657 7.2638 7.4375 7.31237 7.4375C7.36139 7.4375 7.4102 7.43654 7.45877 7.43466C8.3097 7.45462 9.1281 7.64881 9.89356 8.0127C10.1664 8.14231 10.4926 8.02635 10.6222 7.75354C10.7519 7.48076 10.6359 7.15452 10.3631 7.02486ZM7.44575 6.34039C7.40137 6.33959 7.35691 6.33918 7.31237 6.33918C7.26823 6.33918 7.2241 6.33962 7.18002 6.34044C5.79383 6.27129 4.68737 5.12181 4.68737 3.71875C4.68737 2.27131 5.86493 1.09375 7.31237 1.09375C8.75981 1.09375 9.93737 2.27131 9.93737 3.71875C9.93737 5.12146 8.83145 6.27071 7.44575 6.34039Z"
                          fill="white"
                        />
                        <path
                          d="M13.7655 10.8555H12.2616V9.35156C12.2616 9.04952 12.0168 8.80469 11.7147 8.80469C11.4127 8.80469 11.1678 9.04952 11.1678 9.35156V10.8555H9.66394C9.3619 10.8555 9.11707 11.1003 9.11707 11.4023C9.11707 11.7044 9.3619 11.9492 9.66394 11.9492H11.1678V13.4531C11.1678 13.7552 11.4127 14 11.7147 14C12.0168 14 12.2616 13.7552 12.2616 13.4531V11.9492H13.7655C14.0675 11.9492 14.3124 11.7044 14.3124 11.4023C14.3124 11.1003 14.0675 10.8555 13.7655 10.8555Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                    <div>
                      <h1 className="addLeadsBtn">Add Leads</h1>
                    </div>
                  </div>
                </button>
              </Link>
            </div>

            <div className="flex flex-row  items-center">
              <div className="flex flex-col ">
                <input
                  value={selectedJobIdFive}
                  onChange={(e) => setSelectedJobIdFive(e.target.value)}
                  type="number"
                  placeholder="Job Id"
                  className="input input-bordered input-warning w-full max-w-xs mt-2 "
                />
              </div>

              <button
                className="btnApplyThree flex ml-10 w-36 h-12 mt-2"
                onClick={handleSearchFive}
              >
                Search
              </button>
              <button
                className="btnClear flex ml-5 w-8 h-12 mt-2 justify-center items-center"
                onClick={handleClearFive}
              >
                clear
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="lg:w-[680px] sm:w-full h-28  flex flex-row lg:gap-5 sm:gap-2 justify-around py-10">
        <button
          onClick={() => handleTabClick(1)}
          className="w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl"
        >
          All
        </button>
        <button
          onClick={() => handleTabClick(2)}
          className="w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl"
        >
          New Leads {newLeads.length}
        </button>
        <button
          onClick={() => handleTabClick(3)}
          className="w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl"
        >
          Published {Publish.length}
        </button>
        <button
          onClick={() => handleTabClick(4)}
          className="w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl"
        >
          Follow Up {FollowUp.length}
        </button>
        <button
          onClick={() => handleTabClick(5)}
          className="w-full px-2 py-2 tabButton text-orange-800 hover:rounded-xl h-10 focus:bg-orange-100 focus:rounded-xl"
        >
          Cancelled {Cancelled.length}
        </button>
      </div>

      {activeTab === 1 && (
        <div className="tab-content w-full ">
          {loading ? (
            <div className="flex justify-center items-center ">
              <LoaderBigTwo></LoaderBigTwo>
            </div>
          ) : (
            <div>
              <div class="relative overflow-x-auto overflow-y-hidden pb-32">
                <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                  <thead class="">
                    <tr>
                      <th scope="col" class="px-6 py-3">
                        <div className="flex flex-row item-center ">
                          <div>
                            <h1 className="TableHeaderText">Id</h1>
                          </div>
                        </div>
                      </th>
                      <th scope="col" class="px-6 py-3">
                        <div className="flex flex-row item-center">
                          <div>
                            <h1 className="TableHeaderText">Date added</h1>
                          </div>
                          <div className="ml-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="13"
                              height="15"
                              viewBox="0 0 13 15"
                              fill="none"
                            >
                              <path
                                d="M9.54554 14.5C9.46181 14.5005 9.37881 14.4844 9.3013 14.4528C9.22378 14.4211 9.15328 14.3745 9.09384 14.3155L6.54905 11.7707C6.42926 11.6509 6.36195 11.4884 6.36195 11.319C6.36195 11.1496 6.42926 10.9871 6.54905 10.8673C6.66885 10.7475 6.83133 10.6802 7.00075 10.6802C7.17017 10.6802 7.33265 10.7475 7.45245 10.8673L8.90934 12.3306V1.13988C8.90934 0.971155 8.97637 0.809336 9.09568 0.690026C9.21499 0.570716 9.37681 0.503689 9.54554 0.503689C9.71426 0.503689 9.87608 0.570716 9.99539 0.690026C10.1147 0.809336 10.1817 0.971155 10.1817 1.13988V12.3306L11.6386 10.8673C11.7584 10.7475 11.9209 10.6802 12.0903 10.6802C12.2597 10.6802 12.4222 10.7475 12.542 10.8673C12.6618 10.9871 12.7291 11.1496 12.7291 11.319C12.7291 11.4884 12.6618 11.6509 12.542 11.7707L9.99723 14.3155C9.93779 14.3745 9.86729 14.4211 9.78977 14.4528C9.71226 14.4844 9.62926 14.5005 9.54554 14.5ZM3.18358 14.5C3.01485 14.5 2.85303 14.433 2.73372 14.3137C2.61441 14.1943 2.54738 14.0325 2.54738 13.8638V2.67312L1.0905 4.13637C0.970699 4.25616 0.808218 4.32346 0.638799 4.32346C0.469379 4.32346 0.306898 4.25616 0.1871 4.13637C0.0673018 4.01657 0 3.85409 0 3.68467C0 3.51525 0.0673018 3.35277 0.1871 3.23297L2.73188 0.688186C2.79102 0.628556 2.86139 0.581227 2.93891 0.548928C3.01644 0.516629 3.0996 0.5 3.18358 0.5C3.26757 0.5 3.35072 0.516629 3.42825 0.548928C3.50577 0.581227 3.57614 0.628556 3.63528 0.688186L6.18006 3.23297C6.29986 3.35277 6.36716 3.51525 6.36716 3.68467C6.36716 3.85409 6.29986 4.01657 6.18006 4.13637C6.06026 4.25616 5.89778 4.32346 5.72836 4.32346C5.55894 4.32346 5.39646 4.25616 5.27666 4.13637L3.81978 2.67312V13.8638C3.81978 14.0325 3.75275 14.1943 3.63344 14.3137C3.51413 14.433 3.35231 14.5 3.18358 14.5Z"
                                fill="#FE7702"
                              />
                            </svg>
                          </div>
                        </div>
                      </th>
                      <th scope="col" class="px-6 py-3">
                        <div className="flex flex-row item-center">
                          <div>
                            <h1 className="TableHeaderText">Name</h1>
                          </div>
                        </div>
                      </th>

                      <th scope="col" class="px-6 py-3">
                        <div className="flex flex-row item-center">
                          <div>
                            <h1 className="TableHeaderText">Stage</h1>
                          </div>
                        </div>
                      </th>
                      <th scope="col" class="px-24 py-3">
                        <div className="flex flex-row item-center">
                          <div>
                            <h1 className="TableHeaderText">Action</h1>
                          </div>
                        </div>
                      </th>
                      <th scope="col" class="px-6 py-3">
                        <h1 className="TableHeaderText">Details</h1>
                      </th>
                    </tr>
                  </thead>
                  {currentItems.map((all, index) => (
                    <tbody
                      key={index}
                      className="w-full text-sm text-left text-gray-500 dark:text-gray-400"
                    >
                      <tr class="bg-white dark:bg-gray-800">
                        <th
                          scope="row"
                          class="px-6 py-4 tableBodyText dark:text-white"
                        >
                          {all.jobId}
                        </th>
                        <td class="px-6 py-4">
                          {new Date(all.joiningDate).toLocaleDateString(
                            "en-GB"
                          )}
                        </td>
                        <td class="px-6 py-4">
                          {all.name} {all.posterName}
                        </td>

                        <div className="dropdown w-28">
                          <div tabIndex={0} role="button" className="roleBtn">
                            {all.leads}
                          </div>
                          <ul
                            tabIndex={0}
                            className="dropdown-content z-[1] menu p-2 shadow rounded-lg border-gray-200 bg-white  w-full"
                          >
                            {all?.leads === "publish" ? (
                              <button
                                disabled
                                className="w-full h-8 bg-orange-200 mt-2  focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Published
                              </button>
                            ) : (
                              <button
                                onClick={() => {
                                  handleMakePublish(all._id); // Call the first function
                                  // Call the second function
                                }}
                                className="w-full h-8 bg-orange-400 mt-2 hover:bg-orange-600 focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Published
                              </button>
                            )}
                            {all?.leads === "followUp" ? (
                              <button
                                disabled
                                className="w-full h-8 bg-orange-200 mt-2  focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Follow Up
                              </button>
                            ) : (
                              <button
                                onClick={() => {
                                  handleMakeFollowUp(all._id); // Call the first function
                                  // Call the second function
                                }}
                                className="w-full h-8 bg-orange-400 mt-2 hover:bg-orange-600 focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Follow Up
                              </button>
                            )}
                       

                            <button
                              onClick={() => {
                                handleButtonClick(all);
                                // Assuming you want to close the dropdown when opening the modal
                              }}
                              className="w-full h-8 bg-orange-400 mt-2 hover:bg-orange-600 focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                            >
                              Cancel
                            </button>
                          </ul>
                        </div>

                        <td className="px-10">
                          <details className="dropdown">
                            <summary className="w-56 rounded-md cursor-pointer btnTextAssign mb-3 h-10 bg-gray-100 px-8 py-3 flex justify-center items-center">
                            {selectedAdminEmail[all._id] || all.assignEmail || "Select Admin"}
                            </summary>
                <ul className="p-2 shadow menu dropdown-content z-[1] overflow-y-auto overflow-x-hidden h-56  scrollbar bg-base-100 rounded-box w-52">
                  {AllAdmin.map(admin => (
                     <button
                     className="w-full my-2 rounded mx-1 btnTextEmail py-1 bg-orange-100 hover:bg-orange-200 focus:bg-orange-300"
                     key={admin.email}
                     onClick={() => handleAdminClick(admin.email, all._id)}
                   >
                     {admin.email}
                   </button>
                  ))}

                </ul>

                              
                          </details>

                        </td>
                        {/* <td>
                        <button onClick={() => handleAssign(all._id)}>Assign</button>

                        </td> */}
                        <td>
                          <Link
                            to={`/dashboardTwo/AdminLeadsDetails/${all._id}`}
                          >
                            <button className="text-white bg-orange-500 w-20 h-10 rounded-lg">
                              View
                            </button>
                          </Link>
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
              <div className="flex items-center justify-center mt-5">
                <nav aria-label="Page navigation example">
                  <ul className="inline-flex -space-x-px text-sm">
                    <li>
                      <button
                        onClick={() => handlePageChange(currentPage - 1)}
                        className={`flex items-center justify-center px-3 h-8 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
                          currentPage === 1
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                      >
                        Previous
                      </button>
                    </li>
                    {generatePaginationButtons()}
                    <li>
                      <button
                        onClick={() => handlePageChange(currentPage + 1)}
                        className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover-bg-gray-100 hover-text-gray-700 dark-bg-gray-800 dark-border-gray-700 dark-text-gray-400 dark-hover-bg-gray-700 dark-hover-text-white ${
                          currentPage === totalPageCount
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
              {isModalOpen && selectedItem && (
                <div className="container max-w-[1000px] mx-auto">
                  <div className="p-10 flex justify-center items-center bg-white w-[380px] h-[300px] border-2 border-gray-200 rounded-lg contentApplicationLeed">
                    <div className="flex flex-col justify-center items-center p-20">
                      <div className="flex justify-end  w-full">
                        <button
                          onClick={() => setModalOpen(false)}
                          className="w-8 h-8 rounded-full flex justify-center items-center bg-orange-300 hover:bg-orange-400"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      </div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="68"
                        height="60"
                        viewBox="0 0 68 60"
                        fill="none"
                      >
                        <path
                          d="M66.2224 49.7273L39.4837 3.43836C38.888 2.39399 38.0266 1.52582 36.9869 0.921949C35.9472 0.318077 34.7663 0 33.5639 0C32.3616 0 31.1807 0.318077 30.141 0.921949C29.1013 1.52582 28.2399 2.39399 27.6441 3.43836L0.905452 49.7273C0.309118 50.7702 -0.00308973 51.9514 2.30503e-05 53.1528C0.00313583 54.3541 0.321461 55.5336 0.923191 56.5734C1.52492 57.6133 2.38899 58.477 3.42906 59.0782C4.46912 59.6795 5.64877 59.9973 6.85014 59.9999H60.2777C61.4837 60.0049 62.6694 59.6898 63.7138 59.0868C64.7581 58.4838 65.6238 57.6144 66.2224 56.5674C66.8326 55.531 67.1545 54.3501 67.1545 53.1474C67.1545 51.9446 66.8326 50.7638 66.2224 49.7273ZM64.0584 55.3238C63.683 55.9947 63.1338 56.552 62.4685 56.9372C61.8032 57.3223 61.0464 57.5211 60.2777 57.5126H6.85014C6.08622 57.5083 5.33673 57.3042 4.67614 56.9205C4.01556 56.5368 3.46687 55.987 3.08461 55.3256C2.70235 54.6641 2.49983 53.9142 2.49716 53.1503C2.49449 52.3864 2.69178 51.635 3.06942 50.971L29.7832 4.68201C30.1701 4.03816 30.7171 3.50539 31.3708 3.13551C32.0246 2.76564 32.763 2.57125 33.5142 2.57125C34.2653 2.57125 35.0037 2.76564 35.6575 3.13551C36.3113 3.50539 36.8582 4.03816 37.2452 4.68201L64.0584 50.971C64.4479 51.6301 64.6534 52.3818 64.6534 53.1474C64.6534 53.913 64.4479 54.6646 64.0584 55.3238ZM32.3203 38.3603V17.3425C32.3203 17.0126 32.4513 16.6963 32.6845 16.4631C32.9178 16.2298 33.2341 16.0988 33.5639 16.0988C33.8938 16.0988 34.2101 16.2298 34.4433 16.4631C34.6766 16.6963 34.8076 17.0126 34.8076 17.3425V38.3603C34.8076 38.6901 34.6766 39.0065 34.4433 39.2397C34.2101 39.4729 33.8938 39.6039 33.5639 39.6039C33.2341 39.6039 32.9178 39.4729 32.6845 39.2397C32.4513 39.0065 32.3203 38.6901 32.3203 38.3603ZM36.0512 47.5634C36.0512 48.0553 35.9054 48.5362 35.6321 48.9452C35.3587 49.3543 34.9703 49.6731 34.5158 49.8613C34.0613 50.0496 33.5612 50.0989 33.0787 50.0029C32.5962 49.9069 32.153 49.67 31.8051 49.3222C31.4573 48.9743 31.2204 48.5311 31.1244 48.0486C31.0284 47.5661 31.0777 47.066 31.2659 46.6115C31.4542 46.157 31.773 45.7685 32.182 45.4952C32.5911 45.2219 33.072 45.076 33.5639 45.076C34.2236 45.076 34.8563 45.3381 35.3227 45.8046C35.7892 46.271 36.0512 46.9037 36.0512 47.5634Z"
                          fill="#0E73B7"
                        />
                      </svg>
                      <p className="reasonTittle mr-5">
                        Reason For Cancellation
                      </p>

                      <select
                        className="select select-primary w-full mt-5"
                        value={selectedReason}
                        onChange={(e) => setSelectedReason(e.target.value)}
                      >
                        <option value="">Select a reason</option>
                        <option value="Late Follow Up">Late Follow Up</option>
                        <option value="Already Found Tutor">
                          Already Found Tutor
                        </option>
                        <option value="Unreachable">Unreachable</option>
                        <option value="Submitted By Mistake">
                          Submitted by Mistake
                        </option>
                        <option value="Doesn't Need TutorAnymore">
                          Doesn't Need Tutor Anymore
                        </option>
                        <option value="Unreasonable Requirements">
                          Unreasonable Requirements
                        </option>
                      </select>
                      <button
                        onClick={() =>
                          handleMakeCancelled(selectedItem._id, selectedReason)
                        }
                        className="ModalSubmit w-56 mt-5"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      )}
      {activeTab === 2 && (
        <div className="tab-content w-full h-96 ">
          {loading ? (
            <div className="flex justify-center items-center ">
              <LoaderBigTwo></LoaderBigTwo>
            </div>
          ) : (
            <div>
              <div class="relative h-[800px] overflow-x-auto overflow-y-hidden">
                <table class="w-full  text-sm text-left text-gray-500 dark:text-gray-400">
                  <thead class="">
                    <tr>
                      <th scope="col" class="px-6 py-3">
                        <div className="flex flex-row item-center ">
                          <div>
                            <h1 className="TableHeaderText">Id</h1>
                          </div>
                        </div>
                      </th>
                      <th scope="col" class="px-6 py-3">
                        <div className="flex flex-row item-center">
                          <div>
                            <h1 className="TableHeaderText">Date added</h1>
                          </div>
                          <div className="ml-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="13"
                              height="15"
                              viewBox="0 0 13 15"
                              fill="none"
                            >
                              <path
                                d="M9.54554 14.5C9.46181 14.5005 9.37881 14.4844 9.3013 14.4528C9.22378 14.4211 9.15328 14.3745 9.09384 14.3155L6.54905 11.7707C6.42926 11.6509 6.36195 11.4884 6.36195 11.319C6.36195 11.1496 6.42926 10.9871 6.54905 10.8673C6.66885 10.7475 6.83133 10.6802 7.00075 10.6802C7.17017 10.6802 7.33265 10.7475 7.45245 10.8673L8.90934 12.3306V1.13988C8.90934 0.971155 8.97637 0.809336 9.09568 0.690026C9.21499 0.570716 9.37681 0.503689 9.54554 0.503689C9.71426 0.503689 9.87608 0.570716 9.99539 0.690026C10.1147 0.809336 10.1817 0.971155 10.1817 1.13988V12.3306L11.6386 10.8673C11.7584 10.7475 11.9209 10.6802 12.0903 10.6802C12.2597 10.6802 12.4222 10.7475 12.542 10.8673C12.6618 10.9871 12.7291 11.1496 12.7291 11.319C12.7291 11.4884 12.6618 11.6509 12.542 11.7707L9.99723 14.3155C9.93779 14.3745 9.86729 14.4211 9.78977 14.4528C9.71226 14.4844 9.62926 14.5005 9.54554 14.5ZM3.18358 14.5C3.01485 14.5 2.85303 14.433 2.73372 14.3137C2.61441 14.1943 2.54738 14.0325 2.54738 13.8638V2.67312L1.0905 4.13637C0.970699 4.25616 0.808218 4.32346 0.638799 4.32346C0.469379 4.32346 0.306898 4.25616 0.1871 4.13637C0.0673018 4.01657 0 3.85409 0 3.68467C0 3.51525 0.0673018 3.35277 0.1871 3.23297L2.73188 0.688186C2.79102 0.628556 2.86139 0.581227 2.93891 0.548928C3.01644 0.516629 3.0996 0.5 3.18358 0.5C3.26757 0.5 3.35072 0.516629 3.42825 0.548928C3.50577 0.581227 3.57614 0.628556 3.63528 0.688186L6.18006 3.23297C6.29986 3.35277 6.36716 3.51525 6.36716 3.68467C6.36716 3.85409 6.29986 4.01657 6.18006 4.13637C6.06026 4.25616 5.89778 4.32346 5.72836 4.32346C5.55894 4.32346 5.39646 4.25616 5.27666 4.13637L3.81978 2.67312V13.8638C3.81978 14.0325 3.75275 14.1943 3.63344 14.3137C3.51413 14.433 3.35231 14.5 3.18358 14.5Z"
                                fill="#FE7702"
                              />
                            </svg>
                          </div>
                        </div>
                      </th>
                      <th scope="col" class="px-6 py-3">
                        <div className="flex flex-row item-center">
                          <div>
                            <h1 className="TableHeaderText">Name</h1>
                          </div>
                        </div>
                      </th>

                      <th scope="col" class="px-6 py-3">
                        <div className="flex flex-row item-center">
                          <div>
                            <h1 className="TableHeaderText">Stage</h1>
                          </div>
                        </div>
                      </th>
                      <th scope="col" class="px-6 py-3">
                        <h1 className="TableHeaderText">Details</h1>
                      </th>
                    </tr>
                  </thead>
                  {currentItemsTwo.map((all, index) => (
                    <tbody
                      key={index}
                      className="w-full text-sm text-left text-gray-500 dark:text-gray-400 "
                    >
                      <tr class="bg-white dark:bg-gray-800">
                        <th
                          scope="row"
                          class="px-6 py-4 tableBodyText dark:text-white"
                        >
                          {all.jobId}
                        </th>
                        <td class="px-6 py-4">
                          {new Date(all.joiningDate).toLocaleDateString(
                            "en-GB"
                          )}
                        </td>
                        <td class="px-6 py-4">
                          {all.name} {all.posterName}
                        </td>

                        <div className="dropdown w-28">
                          <div tabIndex={0} role="button" className="roleBtn">
                            {all.leads}
                          </div>
                          <ul
                            tabIndex={0}
                            className="dropdown-content z-[1] menu p-2 shadow rounded-lg border-gray-200 bg-white  w-full"
                          >
                            {all?.leads === "publish" ? (
                              <button
                                disabled
                                className="w-full h-8 bg-orange-200 mt-2  focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Published
                              </button>
                            ) : (
                              <button
                                onClick={() => {
                                  handleMakePublish(all._id); // Call the first function
                                  // Call the second function
                                }}
                                className="w-full h-8 bg-orange-400 mt-2 hover:bg-orange-600 focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Published
                              </button>
                            )}
                            {all?.leads === "followUp" ? (
                              <button
                                disabled
                                className="w-full h-8 bg-orange-200 mt-2  focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Follow Up
                              </button>
                            ) : (
                              <button
                                onClick={() => {
                                  handleMakeFollowUp(all._id); // Call the first function
                                  // Call the second function
                                }}
                                className="w-full h-8 bg-orange-400 mt-2 hover:bg-orange-600 focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Follow Up
                              </button>
                            )}
                            {/* {all?.leads === "cancelled" ? (
                              <button
                                disabled
                                className="w-full h-8 bg-orange-200 mt-2  focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Cancelled
                              </button>
                            ) : (
                              <button
                                onClick={() => {
                                  handleMakeCancelled(all._id); // Call the first function
                                  // Call the second function
                                }}
                                className="w-full h-8 bg-orange-400 mt-2 hover:bg-orange-600 focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Cancelled
                              </button>
                            )} */}

                            <button
                              onClick={() => {
                                handleButtonClick(all);
                                // Assuming you want to close the dropdown when opening the modal
                              }}
                              className="w-full h-8 bg-orange-400 mt-2 hover:bg-orange-600 focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                            >
                              Cancel
                            </button>
                          </ul>
                        </div>

                        <td>
                          <Link
                            to={`/dashboardTwo/AdminLeadsDetails/${all._id}`}
                          >
                            <button className="text-white bg-orange-500 w-20 h-10 rounded-lg">
                              View
                            </button>
                          </Link>
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
              <div className="flex items-center justify-center mt-5">
                <nav aria-label="Page navigation example">
                  <ul className="inline-flex -space-x-px text-sm">
                    <li>
                      <button
                        onClick={() => handlePageChangeTwo(currentPageTwo - 1)}
                        className={`flex items-center justify-center px-3 h-8 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
                          currentPageTwo === 1
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                      >
                        Previous
                      </button>
                    </li>
                    {generatePaginationButtonsTwo()}
                    <li>
                      <button
                        onClick={() => handlePageChangeTwo(currentPageTwo + 1)}
                        className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover-bg-gray-100 hover-text-gray-700 dark-bg-gray-800 dark-border-gray-700 dark-text-gray-400 dark-hover-bg-gray-700 dark-hover-text-white ${
                          currentPageTwo === totalPageCountTwo
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
              {isModalOpen && selectedItem && (
                <div className="container max-w-[1000px] mx-auto">
                  <div className="p-10 flex justify-center items-center bg-white w-[380px] h-[300px] border-2 border-gray-200 rounded-lg contentApplicationLeed">
                    <div className="flex flex-col justify-center items-center p-20">
                      <div className="flex justify-end  w-full">
                        <button
                          onClick={() => setModalOpen(false)}
                          className="w-8 h-8 rounded-full flex justify-center items-center bg-orange-300 hover:bg-orange-400"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      </div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="68"
                        height="60"
                        viewBox="0 0 68 60"
                        fill="none"
                      >
                        <path
                          d="M66.2224 49.7273L39.4837 3.43836C38.888 2.39399 38.0266 1.52582 36.9869 0.921949C35.9472 0.318077 34.7663 0 33.5639 0C32.3616 0 31.1807 0.318077 30.141 0.921949C29.1013 1.52582 28.2399 2.39399 27.6441 3.43836L0.905452 49.7273C0.309118 50.7702 -0.00308973 51.9514 2.30503e-05 53.1528C0.00313583 54.3541 0.321461 55.5336 0.923191 56.5734C1.52492 57.6133 2.38899 58.477 3.42906 59.0782C4.46912 59.6795 5.64877 59.9973 6.85014 59.9999H60.2777C61.4837 60.0049 62.6694 59.6898 63.7138 59.0868C64.7581 58.4838 65.6238 57.6144 66.2224 56.5674C66.8326 55.531 67.1545 54.3501 67.1545 53.1474C67.1545 51.9446 66.8326 50.7638 66.2224 49.7273ZM64.0584 55.3238C63.683 55.9947 63.1338 56.552 62.4685 56.9372C61.8032 57.3223 61.0464 57.5211 60.2777 57.5126H6.85014C6.08622 57.5083 5.33673 57.3042 4.67614 56.9205C4.01556 56.5368 3.46687 55.987 3.08461 55.3256C2.70235 54.6641 2.49983 53.9142 2.49716 53.1503C2.49449 52.3864 2.69178 51.635 3.06942 50.971L29.7832 4.68201C30.1701 4.03816 30.7171 3.50539 31.3708 3.13551C32.0246 2.76564 32.763 2.57125 33.5142 2.57125C34.2653 2.57125 35.0037 2.76564 35.6575 3.13551C36.3113 3.50539 36.8582 4.03816 37.2452 4.68201L64.0584 50.971C64.4479 51.6301 64.6534 52.3818 64.6534 53.1474C64.6534 53.913 64.4479 54.6646 64.0584 55.3238ZM32.3203 38.3603V17.3425C32.3203 17.0126 32.4513 16.6963 32.6845 16.4631C32.9178 16.2298 33.2341 16.0988 33.5639 16.0988C33.8938 16.0988 34.2101 16.2298 34.4433 16.4631C34.6766 16.6963 34.8076 17.0126 34.8076 17.3425V38.3603C34.8076 38.6901 34.6766 39.0065 34.4433 39.2397C34.2101 39.4729 33.8938 39.6039 33.5639 39.6039C33.2341 39.6039 32.9178 39.4729 32.6845 39.2397C32.4513 39.0065 32.3203 38.6901 32.3203 38.3603ZM36.0512 47.5634C36.0512 48.0553 35.9054 48.5362 35.6321 48.9452C35.3587 49.3543 34.9703 49.6731 34.5158 49.8613C34.0613 50.0496 33.5612 50.0989 33.0787 50.0029C32.5962 49.9069 32.153 49.67 31.8051 49.3222C31.4573 48.9743 31.2204 48.5311 31.1244 48.0486C31.0284 47.5661 31.0777 47.066 31.2659 46.6115C31.4542 46.157 31.773 45.7685 32.182 45.4952C32.5911 45.2219 33.072 45.076 33.5639 45.076C34.2236 45.076 34.8563 45.3381 35.3227 45.8046C35.7892 46.271 36.0512 46.9037 36.0512 47.5634Z"
                          fill="#0E73B7"
                        />
                      </svg>
                      <p className="reasonTittle mr-5">
                        Reason For Cancellation
                      </p>

                      <select
                        className="select select-primary w-full mt-5"
                        value={selectedReason}
                        onChange={(e) => setSelectedReason(e.target.value)}
                      >
                        <option value="">Select a reason</option>
                        <option value="Late Follow Up">Late Follow Up</option>
                        <option value="Already Found Tutor">
                          Already Found Tutor
                        </option>
                        <option value="Unreachable">Unreachable</option>
                        <option value="Submitted By Mistake">
                          Submitted by Mistake
                        </option>
                        <option value="Doesn't Need TutorAnymore">
                          Doesn't Need Tutor Anymore
                        </option>
                        <option value="Unreasonable Requirements">
                          Unreasonable Requirements
                        </option>
                      </select>
                      <button
                        onClick={() =>
                          handleMakeCancelled(selectedItem._id, selectedReason)
                        }
                        className="ModalSubmit w-56 mt-5"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      )}
      {activeTab === 3 && (
        <div className="tab-content w-full h-96 ">
          {loading ? (
            <div className="flex justify-center items-center ">
              <LoaderBigTwo></LoaderBigTwo>
            </div>
          ) : (
            <div>
              <div class="relative overflow-x-auto overflow-y-hidden pb-48">
                <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                  <thead class="">
                    <tr>
                      <th scope="col" class="px-6 py-3">
                        <div className="flex flex-row item-center ">
                          <div>
                            <h1 className="TableHeaderText">Id</h1>
                          </div>
                        </div>
                      </th>
                      <th scope="col" class="px-6 py-3">
                        <div className="flex flex-row item-center">
                          <div>
                            <h1 className="TableHeaderText">Date added</h1>
                          </div>
                          <div className="ml-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="13"
                              height="15"
                              viewBox="0 0 13 15"
                              fill="none"
                            >
                              <path
                                d="M9.54554 14.5C9.46181 14.5005 9.37881 14.4844 9.3013 14.4528C9.22378 14.4211 9.15328 14.3745 9.09384 14.3155L6.54905 11.7707C6.42926 11.6509 6.36195 11.4884 6.36195 11.319C6.36195 11.1496 6.42926 10.9871 6.54905 10.8673C6.66885 10.7475 6.83133 10.6802 7.00075 10.6802C7.17017 10.6802 7.33265 10.7475 7.45245 10.8673L8.90934 12.3306V1.13988C8.90934 0.971155 8.97637 0.809336 9.09568 0.690026C9.21499 0.570716 9.37681 0.503689 9.54554 0.503689C9.71426 0.503689 9.87608 0.570716 9.99539 0.690026C10.1147 0.809336 10.1817 0.971155 10.1817 1.13988V12.3306L11.6386 10.8673C11.7584 10.7475 11.9209 10.6802 12.0903 10.6802C12.2597 10.6802 12.4222 10.7475 12.542 10.8673C12.6618 10.9871 12.7291 11.1496 12.7291 11.319C12.7291 11.4884 12.6618 11.6509 12.542 11.7707L9.99723 14.3155C9.93779 14.3745 9.86729 14.4211 9.78977 14.4528C9.71226 14.4844 9.62926 14.5005 9.54554 14.5ZM3.18358 14.5C3.01485 14.5 2.85303 14.433 2.73372 14.3137C2.61441 14.1943 2.54738 14.0325 2.54738 13.8638V2.67312L1.0905 4.13637C0.970699 4.25616 0.808218 4.32346 0.638799 4.32346C0.469379 4.32346 0.306898 4.25616 0.1871 4.13637C0.0673018 4.01657 0 3.85409 0 3.68467C0 3.51525 0.0673018 3.35277 0.1871 3.23297L2.73188 0.688186C2.79102 0.628556 2.86139 0.581227 2.93891 0.548928C3.01644 0.516629 3.0996 0.5 3.18358 0.5C3.26757 0.5 3.35072 0.516629 3.42825 0.548928C3.50577 0.581227 3.57614 0.628556 3.63528 0.688186L6.18006 3.23297C6.29986 3.35277 6.36716 3.51525 6.36716 3.68467C6.36716 3.85409 6.29986 4.01657 6.18006 4.13637C6.06026 4.25616 5.89778 4.32346 5.72836 4.32346C5.55894 4.32346 5.39646 4.25616 5.27666 4.13637L3.81978 2.67312V13.8638C3.81978 14.0325 3.75275 14.1943 3.63344 14.3137C3.51413 14.433 3.35231 14.5 3.18358 14.5Z"
                                fill="#FE7702"
                              />
                            </svg>
                          </div>
                        </div>
                      </th>
                      <th scope="col" class="px-6 py-3">
                        <div className="flex flex-row item-center">
                          <div>
                            <h1 className="TableHeaderText">Name</h1>
                          </div>
                        </div>
                      </th>

                      <th scope="col" class="px-6 py-3">
                        <div className="flex flex-row item-center">
                          <div>
                            <h1 className="TableHeaderText">Stage</h1>
                          </div>
                        </div>
                      </th>
                      <th scope="col" class="px-6 py-3">
                        <h1 className="TableHeaderText">Details</h1>
                      </th>
                    </tr>
                  </thead>
                  {currentItemsThree.map((all, index) => (
                    <tbody
                      key={index}
                      className="w-full text-sm text-left text-gray-500 dark:text-gray-400"
                    >
                      <tr class="bg-white dark:bg-gray-800">
                        <th
                          scope="row"
                          class="px-6 py-4 tableBodyText dark:text-white"
                        >
                          {all.jobId}
                        </th>
                        <td class="px-6 py-4">
                          {new Date(all.joiningDate).toLocaleDateString(
                            "en-GB"
                          )}
                        </td>
                        <td class="px-6 py-4">
                          {all.name} {all.posterName}
                        </td>

                        <div className="dropdown w-28">
                          <div tabIndex={0} role="button" className="roleBtn">
                            {all.leads}
                          </div>
                          <ul
                            tabIndex={0}
                            className="dropdown-content z-[1] menu p-2 shadow rounded-lg border-gray-200 bg-white  w-full"
                          >
                            {all?.leads === "publish" ? (
                              <button
                                disabled
                                className="w-full h-8 bg-orange-200 mt-2  focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Published
                              </button>
                            ) : (
                              <button
                                onClick={() => {
                                  handleMakePublish(all._id); // Call the first function
                                  // Call the second function
                                }}
                                className="w-full h-8 bg-orange-400 mt-2 hover:bg-orange-600 focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Published
                              </button>
                            )}
                            {all?.leads === "followUp" ? (
                              <button
                                disabled
                                className="w-full h-8 bg-orange-200 mt-2  focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Follow Up
                              </button>
                            ) : (
                              <button
                                onClick={() => {
                                  handleMakeFollowUp(all._id); // Call the first function
                                  // Call the second function
                                }}
                                className="w-full h-8 bg-orange-400 mt-2 hover:bg-orange-600 focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Follow Up
                              </button>
                            )}
                            {/* {all?.leads === "cancelled" ? (
                              <button
                                disabled
                                className="w-full h-8 bg-orange-200 mt-2  focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Cancelled
                              </button>
                            ) : (
                              <button
                                onClick={() => {
                                  handleMakeCancelled(all._id); // Call the first function
                                  // Call the second function
                                }}
                                className="w-full h-8 bg-orange-400 mt-2 hover:bg-orange-600 focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Cancelled
                              </button>
                            )} */}

                            <button
                              onClick={() => {
                                handleButtonClick(all);
                                // Assuming you want to close the dropdown when opening the modal
                              }}
                              className="w-full h-8 bg-orange-400 mt-2 hover:bg-orange-600 focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                            >
                              Cancel
                            </button>
                          </ul>
                        </div>

                        <td>
                          <Link
                            to={`/dashboardTwo/AdminLeadsDetails/${all._id}`}
                          >
                            <button className="text-white bg-orange-500 w-20 h-10 rounded-lg">
                              View
                            </button>
                          </Link>
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
              <div className="flex items-center justify-center mt-5">
                <nav aria-label="Page navigation example">
                  <ul className="inline-flex -space-x-px text-sm">
                    <li>
                      <button
                        onClick={() =>
                          handlePageChangeThree(currentPageThree - 1)
                        }
                        className={`flex items-center justify-center px-3 h-8 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
                          currentPageThree === 1
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                      >
                        Previous
                      </button>
                    </li>
                    {generatePaginationButtonsThree()}
                    <li>
                      <button
                        onClick={() =>
                          handlePageChangeThree(currentPageThree + 1)
                        }
                        className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover-bg-gray-100 hover-text-gray-700 dark-bg-gray-800 dark-border-gray-700 dark-text-gray-400 dark-hover-bg-gray-700 dark-hover-text-white ${
                          currentPageThree === totalPageCountThree
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>

              {isModalOpen && selectedItem && (
                <div className="container max-w-[1000px] mx-auto">
                  <div className="p-10 flex justify-center items-center bg-white w-[380px] h-[300px] border-2 border-gray-200 rounded-lg contentApplicationLeed">
                    <div className="flex flex-col justify-center items-center p-20">
                      <div className="flex justify-end  w-full">
                        <button
                          onClick={() => setModalOpen(false)}
                          className="w-8 h-8 rounded-full flex justify-center items-center bg-orange-300 hover:bg-orange-400"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      </div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="68"
                        height="60"
                        viewBox="0 0 68 60"
                        fill="none"
                      >
                        <path
                          d="M66.2224 49.7273L39.4837 3.43836C38.888 2.39399 38.0266 1.52582 36.9869 0.921949C35.9472 0.318077 34.7663 0 33.5639 0C32.3616 0 31.1807 0.318077 30.141 0.921949C29.1013 1.52582 28.2399 2.39399 27.6441 3.43836L0.905452 49.7273C0.309118 50.7702 -0.00308973 51.9514 2.30503e-05 53.1528C0.00313583 54.3541 0.321461 55.5336 0.923191 56.5734C1.52492 57.6133 2.38899 58.477 3.42906 59.0782C4.46912 59.6795 5.64877 59.9973 6.85014 59.9999H60.2777C61.4837 60.0049 62.6694 59.6898 63.7138 59.0868C64.7581 58.4838 65.6238 57.6144 66.2224 56.5674C66.8326 55.531 67.1545 54.3501 67.1545 53.1474C67.1545 51.9446 66.8326 50.7638 66.2224 49.7273ZM64.0584 55.3238C63.683 55.9947 63.1338 56.552 62.4685 56.9372C61.8032 57.3223 61.0464 57.5211 60.2777 57.5126H6.85014C6.08622 57.5083 5.33673 57.3042 4.67614 56.9205C4.01556 56.5368 3.46687 55.987 3.08461 55.3256C2.70235 54.6641 2.49983 53.9142 2.49716 53.1503C2.49449 52.3864 2.69178 51.635 3.06942 50.971L29.7832 4.68201C30.1701 4.03816 30.7171 3.50539 31.3708 3.13551C32.0246 2.76564 32.763 2.57125 33.5142 2.57125C34.2653 2.57125 35.0037 2.76564 35.6575 3.13551C36.3113 3.50539 36.8582 4.03816 37.2452 4.68201L64.0584 50.971C64.4479 51.6301 64.6534 52.3818 64.6534 53.1474C64.6534 53.913 64.4479 54.6646 64.0584 55.3238ZM32.3203 38.3603V17.3425C32.3203 17.0126 32.4513 16.6963 32.6845 16.4631C32.9178 16.2298 33.2341 16.0988 33.5639 16.0988C33.8938 16.0988 34.2101 16.2298 34.4433 16.4631C34.6766 16.6963 34.8076 17.0126 34.8076 17.3425V38.3603C34.8076 38.6901 34.6766 39.0065 34.4433 39.2397C34.2101 39.4729 33.8938 39.6039 33.5639 39.6039C33.2341 39.6039 32.9178 39.4729 32.6845 39.2397C32.4513 39.0065 32.3203 38.6901 32.3203 38.3603ZM36.0512 47.5634C36.0512 48.0553 35.9054 48.5362 35.6321 48.9452C35.3587 49.3543 34.9703 49.6731 34.5158 49.8613C34.0613 50.0496 33.5612 50.0989 33.0787 50.0029C32.5962 49.9069 32.153 49.67 31.8051 49.3222C31.4573 48.9743 31.2204 48.5311 31.1244 48.0486C31.0284 47.5661 31.0777 47.066 31.2659 46.6115C31.4542 46.157 31.773 45.7685 32.182 45.4952C32.5911 45.2219 33.072 45.076 33.5639 45.076C34.2236 45.076 34.8563 45.3381 35.3227 45.8046C35.7892 46.271 36.0512 46.9037 36.0512 47.5634Z"
                          fill="#0E73B7"
                        />
                      </svg>
                      <p className="reasonTittle mr-5">
                        Reason For Cancellation
                      </p>

                      <select
                        className="select select-primary w-full mt-5"
                        value={selectedReason}
                        onChange={(e) => setSelectedReason(e.target.value)}
                      >
                        <option value="">Select a reason</option>
                        <option value="Late Follow Up">Late Follow Up</option>
                        <option value="Already Found Tutor">
                          Already Found Tutor
                        </option>
                        <option value="Unreachable">Unreachable</option>
                        <option value="Submitted By Mistake">
                          Submitted by Mistake
                        </option>
                        <option value="Doesn't Need TutorAnymore">
                          Doesn't Need Tutor Anymore
                        </option>
                        <option value="Unreasonable Requirements">
                          Unreasonable Requirements
                        </option>
                      </select>
                      <button
                        onClick={() =>
                          handleMakeCancelled(selectedItem._id, selectedReason)
                        }
                        className="ModalSubmit w-56 mt-5"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      )}
      {activeTab === 4 && (
        <div className="tab-content w-full h-96 ">
          {loading ? (
            <div className="flex justify-center items-center ">
              <LoaderBigTwo></LoaderBigTwo>
            </div>
          ) : (
            <div>
              <div class="relative overflow-x-auto overflow-y-hidden pb-48">
                <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                  <thead class="">
                    <tr>
                      <th scope="col" class="px-6 py-3">
                        <div className="flex flex-row item-center ">
                          <div>
                            <h1 className="TableHeaderText">Id</h1>
                          </div>
                        </div>
                      </th>
                      <th scope="col" class="px-6 py-3">
                        <div className="flex flex-row item-center">
                          <div>
                            <h1 className="TableHeaderText">Date added</h1>
                          </div>
                          <div className="ml-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="13"
                              height="15"
                              viewBox="0 0 13 15"
                              fill="none"
                            >
                              <path
                                d="M9.54554 14.5C9.46181 14.5005 9.37881 14.4844 9.3013 14.4528C9.22378 14.4211 9.15328 14.3745 9.09384 14.3155L6.54905 11.7707C6.42926 11.6509 6.36195 11.4884 6.36195 11.319C6.36195 11.1496 6.42926 10.9871 6.54905 10.8673C6.66885 10.7475 6.83133 10.6802 7.00075 10.6802C7.17017 10.6802 7.33265 10.7475 7.45245 10.8673L8.90934 12.3306V1.13988C8.90934 0.971155 8.97637 0.809336 9.09568 0.690026C9.21499 0.570716 9.37681 0.503689 9.54554 0.503689C9.71426 0.503689 9.87608 0.570716 9.99539 0.690026C10.1147 0.809336 10.1817 0.971155 10.1817 1.13988V12.3306L11.6386 10.8673C11.7584 10.7475 11.9209 10.6802 12.0903 10.6802C12.2597 10.6802 12.4222 10.7475 12.542 10.8673C12.6618 10.9871 12.7291 11.1496 12.7291 11.319C12.7291 11.4884 12.6618 11.6509 12.542 11.7707L9.99723 14.3155C9.93779 14.3745 9.86729 14.4211 9.78977 14.4528C9.71226 14.4844 9.62926 14.5005 9.54554 14.5ZM3.18358 14.5C3.01485 14.5 2.85303 14.433 2.73372 14.3137C2.61441 14.1943 2.54738 14.0325 2.54738 13.8638V2.67312L1.0905 4.13637C0.970699 4.25616 0.808218 4.32346 0.638799 4.32346C0.469379 4.32346 0.306898 4.25616 0.1871 4.13637C0.0673018 4.01657 0 3.85409 0 3.68467C0 3.51525 0.0673018 3.35277 0.1871 3.23297L2.73188 0.688186C2.79102 0.628556 2.86139 0.581227 2.93891 0.548928C3.01644 0.516629 3.0996 0.5 3.18358 0.5C3.26757 0.5 3.35072 0.516629 3.42825 0.548928C3.50577 0.581227 3.57614 0.628556 3.63528 0.688186L6.18006 3.23297C6.29986 3.35277 6.36716 3.51525 6.36716 3.68467C6.36716 3.85409 6.29986 4.01657 6.18006 4.13637C6.06026 4.25616 5.89778 4.32346 5.72836 4.32346C5.55894 4.32346 5.39646 4.25616 5.27666 4.13637L3.81978 2.67312V13.8638C3.81978 14.0325 3.75275 14.1943 3.63344 14.3137C3.51413 14.433 3.35231 14.5 3.18358 14.5Z"
                                fill="#FE7702"
                              />
                            </svg>
                          </div>
                        </div>
                      </th>
                      <th scope="col" class="px-6 py-3">
                        <div className="flex flex-row item-center">
                          <div>
                            <h1 className="TableHeaderText">Name</h1>
                          </div>
                        </div>
                      </th>
                      <th scope="col" class="px-6 py-3">
                        <h1 className="TableHeaderText">Select Date</h1>
                      </th>
                      <th scope="col" class="px-6 py-3">
                        <h1 className="TableHeaderText">Reminder</h1>
                      </th>

                      <th scope="col" class="px-6 py-3">
                        <div className="flex flex-row item-center">
                          <div>
                            <h1 className="TableHeaderText">Stage</h1>
                          </div>
                        </div>
                      </th>
                      <th scope="col" class="px-6 py-3">
                        <h1 className="TableHeaderText">Details</h1>
                      </th>
                    </tr>
                  </thead>
                  {currentItemsFour.map((all, index) => (
                    <tbody
                      key={index}
                      className="w-full text-sm text-left text-gray-500 dark:text-gray-400"
                    >
                      <tr class="bg-white dark:bg-gray-800">
                        <th
                          scope="row"
                          class="px-3 py-4 tableBodyText dark:text-white"
                        >
                          {all.jobId}
                        </th>
                        <td class="px-3 py-4">
                          {new Date(all.joiningDate).toLocaleDateString(
                            "en-GB"
                          )}
                        </td>
                        <td class="px-3 py-4">
                          {all.name} {all.posterName}
                        </td>
                        <td class="px-3 py-4 flex flex-row">
                          <DatePicker
                            placeholderText="Select Dates   ↓"
                            dateFormat="dd/MM/yyyy"
                            selected={selectedDates[index]}
                            className="calenderMjrLeadsForm focus:ring-orange-200 focus:border-orange-200 bg-gray-200 h-10 w-28 rounded-md placeholder:text-gray-900"
                            onChange={(date) => handleDateChange(date, index)}
                          />

                          <button
                            onClick={() => {
                              handleDateUpdate(all._id, index, selectedDates); // Call the first function
                              // Call the second function
                            }}
                            className="text-white bg-orange-500 w-20 h-10 rounded-lg ml-3"
                          >
                            Update
                          </button>
                        </td>
                        <td class="px-3 py-4">
                          <h1>
                            {new Date(
                              all.updateFollowUpDate
                            ).toLocaleDateString("en-GB")}
                          </h1>
                        </td>
                        <td class="px-3 py-4">
                          <div className="dropdown w-28">
                            <div tabIndex={0} role="button" className="roleBtn">
                              {all.leads}
                            </div>
                            <ul
                              tabIndex={0}
                              className="dropdown-content z-[1] menu p-2 shadow rounded-lg border-gray-200 bg-white  w-full"
                            >
                              {all?.leads === "publish" ? (
                                <button
                                  disabled
                                  className="w-full h-8 bg-orange-200 mt-2  focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                                >
                                  Published
                                </button>
                              ) : (
                                <button
                                  onClick={() => {
                                    handleMakePublish(all._id); // Call the first function
                                    // Call the second function
                                  }}
                                  className="w-full h-8 bg-orange-400 mt-2 hover:bg-orange-600 focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                                >
                                  Published
                                </button>
                              )}
                              {all?.leads === "followUp" ? (
                                <button
                                  disabled
                                  className="w-full h-8 bg-orange-200 mt-2  focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                                >
                                  Follow Up
                                </button>
                              ) : (
                                <button
                                  onClick={() => {
                                    handleMakeFollowUp(all._id); // Call the first function
                                    // Call the second function
                                  }}
                                  className="w-full h-8 bg-orange-400 mt-2 hover:bg-orange-600 focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                                >
                                  Follow Up
                                </button>
                              )}
                              {/* {all?.leads === "cancelled" ? (
                              <button
                                disabled
                                className="w-full h-8 bg-orange-200 mt-2  focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Cancelled
                              </button>
                            ) : (
                              <button
                                onClick={() => {
                                  handleMakeCancelled(all._id); // Call the first function
                                  // Call the second function
                                }}
                                className="w-full h-8 bg-orange-400 mt-2 hover:bg-orange-600 focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Cancelled
                              </button>
                            )} */}

                              <button
                                onClick={() => {
                                  handleButtonClick(all);
                                  // Assuming you want to close the dropdown when opening the modal
                                }}
                                className="w-full h-8 bg-orange-400 mt-2 hover:bg-orange-600 focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Cancel
                              </button>
                            </ul>
                          </div>
                        </td>

                        <td class="px-3 py-4">
                          <Link
                            to={`/dashboardTwo/AdminLeadsDetails/${all._id}`}
                          >
                            <button className="text-white bg-orange-500 w-20 h-10 rounded-lg">
                              View
                            </button>
                          </Link>
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
              <div className="flex items-center justify-center mt-5">
                <nav aria-label="Page navigation example">
                  <ul className="inline-flex -space-x-px text-sm">
                    <li>
                      <button
                        onClick={() =>
                          handlePageChangeFour(currentPageFour - 1)
                        }
                        className={`flex items-center justify-center px-3 h-8 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
                          currentPageFour === 1
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                      >
                        Previous
                      </button>
                    </li>
                    {generatePaginationButtonsFour()}
                    <li>
                      <button
                        onClick={() =>
                          handlePageChangeFour(currentPageFour + 1)
                        }
                        className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover-bg-gray-100 hover-text-gray-700 dark-bg-gray-800 dark-border-gray-700 dark-text-gray-400 dark-hover-bg-gray-700 dark-hover-text-white ${
                          currentPageFour === totalPageCountFour
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>

              {isModalOpen && selectedItem && (
                <div className="container max-w-[1000px] mx-auto">
                  <div className="p-10 flex justify-center items-center bg-white w-[380px] h-[300px] border-2 border-gray-200 rounded-lg contentApplicationLeed">
                    <div className="flex flex-col justify-center items-center p-20">
                      <div className="flex justify-end  w-full">
                        <button
                          onClick={() => setModalOpen(false)}
                          className="w-8 h-8 rounded-full flex justify-center items-center bg-orange-300 hover:bg-orange-400"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      </div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="68"
                        height="60"
                        viewBox="0 0 68 60"
                        fill="none"
                      >
                        <path
                          d="M66.2224 49.7273L39.4837 3.43836C38.888 2.39399 38.0266 1.52582 36.9869 0.921949C35.9472 0.318077 34.7663 0 33.5639 0C32.3616 0 31.1807 0.318077 30.141 0.921949C29.1013 1.52582 28.2399 2.39399 27.6441 3.43836L0.905452 49.7273C0.309118 50.7702 -0.00308973 51.9514 2.30503e-05 53.1528C0.00313583 54.3541 0.321461 55.5336 0.923191 56.5734C1.52492 57.6133 2.38899 58.477 3.42906 59.0782C4.46912 59.6795 5.64877 59.9973 6.85014 59.9999H60.2777C61.4837 60.0049 62.6694 59.6898 63.7138 59.0868C64.7581 58.4838 65.6238 57.6144 66.2224 56.5674C66.8326 55.531 67.1545 54.3501 67.1545 53.1474C67.1545 51.9446 66.8326 50.7638 66.2224 49.7273ZM64.0584 55.3238C63.683 55.9947 63.1338 56.552 62.4685 56.9372C61.8032 57.3223 61.0464 57.5211 60.2777 57.5126H6.85014C6.08622 57.5083 5.33673 57.3042 4.67614 56.9205C4.01556 56.5368 3.46687 55.987 3.08461 55.3256C2.70235 54.6641 2.49983 53.9142 2.49716 53.1503C2.49449 52.3864 2.69178 51.635 3.06942 50.971L29.7832 4.68201C30.1701 4.03816 30.7171 3.50539 31.3708 3.13551C32.0246 2.76564 32.763 2.57125 33.5142 2.57125C34.2653 2.57125 35.0037 2.76564 35.6575 3.13551C36.3113 3.50539 36.8582 4.03816 37.2452 4.68201L64.0584 50.971C64.4479 51.6301 64.6534 52.3818 64.6534 53.1474C64.6534 53.913 64.4479 54.6646 64.0584 55.3238ZM32.3203 38.3603V17.3425C32.3203 17.0126 32.4513 16.6963 32.6845 16.4631C32.9178 16.2298 33.2341 16.0988 33.5639 16.0988C33.8938 16.0988 34.2101 16.2298 34.4433 16.4631C34.6766 16.6963 34.8076 17.0126 34.8076 17.3425V38.3603C34.8076 38.6901 34.6766 39.0065 34.4433 39.2397C34.2101 39.4729 33.8938 39.6039 33.5639 39.6039C33.2341 39.6039 32.9178 39.4729 32.6845 39.2397C32.4513 39.0065 32.3203 38.6901 32.3203 38.3603ZM36.0512 47.5634C36.0512 48.0553 35.9054 48.5362 35.6321 48.9452C35.3587 49.3543 34.9703 49.6731 34.5158 49.8613C34.0613 50.0496 33.5612 50.0989 33.0787 50.0029C32.5962 49.9069 32.153 49.67 31.8051 49.3222C31.4573 48.9743 31.2204 48.5311 31.1244 48.0486C31.0284 47.5661 31.0777 47.066 31.2659 46.6115C31.4542 46.157 31.773 45.7685 32.182 45.4952C32.5911 45.2219 33.072 45.076 33.5639 45.076C34.2236 45.076 34.8563 45.3381 35.3227 45.8046C35.7892 46.271 36.0512 46.9037 36.0512 47.5634Z"
                          fill="#0E73B7"
                        />
                      </svg>
                      <p className="reasonTittle mr-5">
                        Reason For Cancellation
                      </p>

                      <select
                        className="select select-primary w-full mt-5"
                        value={selectedReason}
                        onChange={(e) => setSelectedReason(e.target.value)}
                      >
                        <option value="">Select a reason</option>
                        <option value="Late Follow Up">Late Follow Up</option>
                        <option value="Already Found Tutor">
                          Already Found Tutor
                        </option>
                        <option value="Unreachable">Unreachable</option>
                        <option value="Submitted By Mistake">
                          Submitted by Mistake
                        </option>
                        <option value="Doesn't Need TutorAnymore">
                          Doesn't Need Tutor Anymore
                        </option>
                        <option value="Unreasonable Requirements">
                          Unreasonable Requirements
                        </option>
                      </select>
                      <button
                        onClick={() =>
                          handleMakeCancelled(selectedItem._id, selectedReason)
                        }
                        className="ModalSubmit w-56 mt-5"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      )}
      {activeTab === 5 && (
        <div className="tab-content w-full h-96 ">
          {loading ? (
            <div className="flex justify-center items-center ">
              <LoaderBigTwo></LoaderBigTwo>
            </div>
          ) : (
            <div>
              <div class="relative overflow-x-auto overflow-y-hidden pb-48">
                <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                  <thead class="">
                    <tr>
                      <th scope="col" class="px-6 py-3">
                        <div className="flex flex-row item-center ">
                          <div>
                            <h1 className="TableHeaderText">Id</h1>
                          </div>
                        </div>
                      </th>
                      <th scope="col" class="px-6 py-3">
                        <div className="flex flex-row item-center">
                          <div>
                            <h1 className="TableHeaderText">Date added</h1>
                          </div>
                          <div className="ml-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="13"
                              height="15"
                              viewBox="0 0 13 15"
                              fill="none"
                            >
                              <path
                                d="M9.54554 14.5C9.46181 14.5005 9.37881 14.4844 9.3013 14.4528C9.22378 14.4211 9.15328 14.3745 9.09384 14.3155L6.54905 11.7707C6.42926 11.6509 6.36195 11.4884 6.36195 11.319C6.36195 11.1496 6.42926 10.9871 6.54905 10.8673C6.66885 10.7475 6.83133 10.6802 7.00075 10.6802C7.17017 10.6802 7.33265 10.7475 7.45245 10.8673L8.90934 12.3306V1.13988C8.90934 0.971155 8.97637 0.809336 9.09568 0.690026C9.21499 0.570716 9.37681 0.503689 9.54554 0.503689C9.71426 0.503689 9.87608 0.570716 9.99539 0.690026C10.1147 0.809336 10.1817 0.971155 10.1817 1.13988V12.3306L11.6386 10.8673C11.7584 10.7475 11.9209 10.6802 12.0903 10.6802C12.2597 10.6802 12.4222 10.7475 12.542 10.8673C12.6618 10.9871 12.7291 11.1496 12.7291 11.319C12.7291 11.4884 12.6618 11.6509 12.542 11.7707L9.99723 14.3155C9.93779 14.3745 9.86729 14.4211 9.78977 14.4528C9.71226 14.4844 9.62926 14.5005 9.54554 14.5ZM3.18358 14.5C3.01485 14.5 2.85303 14.433 2.73372 14.3137C2.61441 14.1943 2.54738 14.0325 2.54738 13.8638V2.67312L1.0905 4.13637C0.970699 4.25616 0.808218 4.32346 0.638799 4.32346C0.469379 4.32346 0.306898 4.25616 0.1871 4.13637C0.0673018 4.01657 0 3.85409 0 3.68467C0 3.51525 0.0673018 3.35277 0.1871 3.23297L2.73188 0.688186C2.79102 0.628556 2.86139 0.581227 2.93891 0.548928C3.01644 0.516629 3.0996 0.5 3.18358 0.5C3.26757 0.5 3.35072 0.516629 3.42825 0.548928C3.50577 0.581227 3.57614 0.628556 3.63528 0.688186L6.18006 3.23297C6.29986 3.35277 6.36716 3.51525 6.36716 3.68467C6.36716 3.85409 6.29986 4.01657 6.18006 4.13637C6.06026 4.25616 5.89778 4.32346 5.72836 4.32346C5.55894 4.32346 5.39646 4.25616 5.27666 4.13637L3.81978 2.67312V13.8638C3.81978 14.0325 3.75275 14.1943 3.63344 14.3137C3.51413 14.433 3.35231 14.5 3.18358 14.5Z"
                                fill="#FE7702"
                              />
                            </svg>
                          </div>
                        </div>
                      </th>
                      <th scope="col" class="px-6 py-3">
                        <div className="flex flex-row item-center">
                          <div>
                            <h1 className="TableHeaderText">Name</h1>
                          </div>
                        </div>
                      </th>

                      <th scope="col" class="px-6 py-3">
                        <div className="flex flex-row item-center">
                          <div>
                            <h1 className="TableHeaderText">Stage</h1>
                          </div>
                        </div>
                      </th>
                      <th scope="col" class="px-6 py-3">
                        <h1 className="TableHeaderText">Details</h1>
                      </th>
                    </tr>
                  </thead>
                  {currentItemsFive.map((all, index) => (
                    <tbody
                      key={index}
                      className="w-full text-sm text-left text-gray-500 dark:text-gray-400"
                    >
                      <tr class="bg-white dark:bg-gray-800">
                        <th
                          scope="row"
                          class="px-6 py-4 tableBodyText dark:text-white"
                        >
                          {all.jobId}
                        </th>
                        <td class="px-6 py-4">
                          {new Date(all.joiningDate).toLocaleDateString(
                            "en-GB"
                          )}
                        </td>
                        <td class="px-6 py-4">
                          {all.name} {all.posterName}
                        </td>

                        <div className="dropdown w-28">
                          <div tabIndex={0} role="button" className="roleBtn">
                            {all.leads}
                          </div>
                          <ul
                            tabIndex={0}
                            className="dropdown-content z-[1] menu p-2 shadow rounded-lg border-gray-200 bg-white  w-full"
                          >
                            {all?.leads === "publish" ? (
                              <button
                                disabled
                                className="w-full h-8 bg-orange-200 mt-2  focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Published
                              </button>
                            ) : (
                              <button
                                onClick={() => {
                                  handleMakePublish(all._id); // Call the first function
                                  // Call the second function
                                }}
                                className="w-full h-8 bg-orange-400 mt-2 hover:bg-orange-600 focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Published
                              </button>
                            )}
                            {all?.leads === "followUp" ? (
                              <button
                                disabled
                                className="w-full h-8 bg-orange-200 mt-2  focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Follow Up
                              </button>
                            ) : (
                              <button
                                onClick={() => {
                                  handleMakeFollowUp(all._id); // Call the first function
                                  // Call the second function
                                }}
                                className="w-full h-8 bg-orange-400 mt-2 hover:bg-orange-600 focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Follow Up
                              </button>
                            )}
                            {/* {all?.leads === "cancelled" ? (
                              <button
                                disabled
                                className="w-full h-8 bg-orange-200 mt-2  focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Cancelled
                              </button>
                            ) : (
                              <button
                                onClick={() => {
                                  handleMakeCancelled(all._id); // Call the first function
                                  // Call the second function
                                }}
                                className="w-full h-8 bg-orange-400 mt-2 hover:bg-orange-600 focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                              >
                                Cancelled
                              </button>
                            )} */}

                            <button
                              onClick={() => {
                                handleButtonClick(all);
                                // Assuming you want to close the dropdown when opening the modal
                              }}
                              className="w-full h-8 bg-orange-400 mt-2 hover:bg-orange-600 focus:bg-orange-600 rounded-md text-white  flex justify-center items-center"
                            >
                              Cancel
                            </button>
                          </ul>
                        </div>

                        <td>
                          <Link
                            to={`/dashboardTwo/AdminLeadsDetails/${all._id}`}
                          >
                            <button className="text-white bg-orange-500 w-20 h-10 rounded-lg">
                              View
                            </button>
                          </Link>
                        </td>
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>
              <div className="flex items-center justify-center mt-5">
                <nav aria-label="Page navigation example">
                  <ul className="inline-flex -space-x-px text-sm">
                    <li>
                      <button
                        onClick={() =>
                          handlePageChangeFive(currentPageFive - 1)
                        }
                        className={`flex items-center justify-center px-3 h-8 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
                          currentPageFive === 1
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                      >
                        Previous
                      </button>
                    </li>
                    {generatePaginationButtonsFive()}
                    <li>
                      <button
                        onClick={() =>
                          handlePageChangeFive(currentPageFive + 1)
                        }
                        className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover-bg-gray-100 hover-text-gray-700 dark-bg-gray-800 dark-border-gray-700 dark-text-gray-400 dark-hover-bg-gray-700 dark-hover-text-white ${
                          currentPageFive === totalPageCountFive
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>

              {isModalOpen && selectedItem && (
                <div className="container max-w-[1000px] mx-auto">
                  <div className="p-10 flex justify-center items-center bg-white w-[380px] h-[300px] border-2 border-gray-200 rounded-lg contentApplicationLeed">
                    <div className="flex flex-col justify-center items-center p-20">
                      <div className="flex justify-end  w-full">
                        <button
                          onClick={() => setModalOpen(false)}
                          className="w-8 h-8 rounded-full flex justify-center items-center bg-orange-300 hover:bg-orange-400"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      </div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="68"
                        height="60"
                        viewBox="0 0 68 60"
                        fill="none"
                      >
                        <path
                          d="M66.2224 49.7273L39.4837 3.43836C38.888 2.39399 38.0266 1.52582 36.9869 0.921949C35.9472 0.318077 34.7663 0 33.5639 0C32.3616 0 31.1807 0.318077 30.141 0.921949C29.1013 1.52582 28.2399 2.39399 27.6441 3.43836L0.905452 49.7273C0.309118 50.7702 -0.00308973 51.9514 2.30503e-05 53.1528C0.00313583 54.3541 0.321461 55.5336 0.923191 56.5734C1.52492 57.6133 2.38899 58.477 3.42906 59.0782C4.46912 59.6795 5.64877 59.9973 6.85014 59.9999H60.2777C61.4837 60.0049 62.6694 59.6898 63.7138 59.0868C64.7581 58.4838 65.6238 57.6144 66.2224 56.5674C66.8326 55.531 67.1545 54.3501 67.1545 53.1474C67.1545 51.9446 66.8326 50.7638 66.2224 49.7273ZM64.0584 55.3238C63.683 55.9947 63.1338 56.552 62.4685 56.9372C61.8032 57.3223 61.0464 57.5211 60.2777 57.5126H6.85014C6.08622 57.5083 5.33673 57.3042 4.67614 56.9205C4.01556 56.5368 3.46687 55.987 3.08461 55.3256C2.70235 54.6641 2.49983 53.9142 2.49716 53.1503C2.49449 52.3864 2.69178 51.635 3.06942 50.971L29.7832 4.68201C30.1701 4.03816 30.7171 3.50539 31.3708 3.13551C32.0246 2.76564 32.763 2.57125 33.5142 2.57125C34.2653 2.57125 35.0037 2.76564 35.6575 3.13551C36.3113 3.50539 36.8582 4.03816 37.2452 4.68201L64.0584 50.971C64.4479 51.6301 64.6534 52.3818 64.6534 53.1474C64.6534 53.913 64.4479 54.6646 64.0584 55.3238ZM32.3203 38.3603V17.3425C32.3203 17.0126 32.4513 16.6963 32.6845 16.4631C32.9178 16.2298 33.2341 16.0988 33.5639 16.0988C33.8938 16.0988 34.2101 16.2298 34.4433 16.4631C34.6766 16.6963 34.8076 17.0126 34.8076 17.3425V38.3603C34.8076 38.6901 34.6766 39.0065 34.4433 39.2397C34.2101 39.4729 33.8938 39.6039 33.5639 39.6039C33.2341 39.6039 32.9178 39.4729 32.6845 39.2397C32.4513 39.0065 32.3203 38.6901 32.3203 38.3603ZM36.0512 47.5634C36.0512 48.0553 35.9054 48.5362 35.6321 48.9452C35.3587 49.3543 34.9703 49.6731 34.5158 49.8613C34.0613 50.0496 33.5612 50.0989 33.0787 50.0029C32.5962 49.9069 32.153 49.67 31.8051 49.3222C31.4573 48.9743 31.2204 48.5311 31.1244 48.0486C31.0284 47.5661 31.0777 47.066 31.2659 46.6115C31.4542 46.157 31.773 45.7685 32.182 45.4952C32.5911 45.2219 33.072 45.076 33.5639 45.076C34.2236 45.076 34.8563 45.3381 35.3227 45.8046C35.7892 46.271 36.0512 46.9037 36.0512 47.5634Z"
                          fill="#0E73B7"
                        />
                      </svg>
                      <p className="reasonTittle mr-5">
                        Reason For Cancellation
                      </p>

                      <select
                        className="select select-primary w-full mt-5"
                        value={selectedReason}
                        onChange={(e) => setSelectedReason(e.target.value)}
                      >
                        <option value="">Select a reason</option>
                        <option value="Late Follow Up">Late Follow Up</option>
                        <option value="Already Found Tutor">
                          Already Found Tutor
                        </option>
                        <option value="Unreachable">Unreachable</option>
                        <option value="Submitted By Mistake">
                          Submitted by Mistake
                        </option>
                        <option value="Doesn't Need TutorAnymore">
                          Doesn't Need Tutor Anymore
                        </option>
                        <option value="Unreasonable Requirements">
                          Unreasonable Requirements
                        </option>
                      </select>
                      <button
                        onClick={() =>
                          handleMakeCancelled(selectedItem._id, selectedReason)
                        }
                        className="ModalSubmit w-56 mt-5"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SuperAdminLeads;
